export const common = {
emptyValue: "—",
a11y: {
goBack: "رجوع",
loading: "جارٍ التحميل",
removePhoto: "إزالة الصورة",
clearSelectedContact: "مسح جهة الاتصال المحددة",
selectNamed: "تحديد {{name}}",
removeStep: "إزالة الخطوة",
removeFilter: "إزالة عامل التصفية",
previousMonth: "الشهر السابق",
nextMonth: "الشهر التالي",
removeRelationship: "إزالة العلاقة",
zoomIn: "تكبير",
zoomOut: "تصغير",
resetView: "إعادة تعيين العرض",
unlinkContact: "إلغاء ربط جهة الاتصال",
removeCharge: "إزالة الرسوم",
removeLineItem: "إزالة البند",
mapUnavailable: "الخريطة غير متاحة على هذا الجهاز",
},
actions: {
  undo: "تراجع",
cancel: "إلغاء",
keep: "إبقاء",
search: "بحث",
takePhoto: "التقاط صورة",
chooseFromGallery: "اختيار من المعرض",
chooseFile: "اختيار ملف",
dismiss: "تجاهل",
tryAgain: "إعادة المحاولة",
saveChanges: "حفظ التغييرات",
saving: "جارٍ الحفظ…",
},
createVerbs: {
guide: "أرشدني",
inspection: "بدء فحص",
job: "تسجيل مهمة",
report: "الإبلاغ عن مشكلة",
asset: "إضافة أصل",
site: "إضافة موقع",
contact: "إضافة جهة اتصال",
share: "مشاركة الأصل",
template: "إنشاء قائمة تحقق",
recurringJobs: "خطط الصيانة",
document: "إضافة مستند",
meterReading: "تسجيل قراءة",
maintenancePlan: "إضافة خطة صيانة",
knowledge: "إضافة معرفة",
relationship: "إضافة علاقة",
assignAsset: "تعيين أصل",
move: "نقل الأصل",
childSite: "إضافة موقع فرعي",
conditionReport: "تقرير الأصل",
siteReport: "Site 360",
},
createNouns: {
  guide: "أرشدني",
  asset: "أصل",
  inspection: "فحص",
  job: "مهمة",
  report: "الإبلاغ عن عطل",
  maintenancePlan: "صيانة",
  contact: "جهة اتصال",
  site: "موقع",
  template: "قائمة تحقق",
},
actVerbs: {
  guide: "أرشدني",
  inspection: "فحص",
  job: "أضف مهمة",
  report: "بلّغ عن مشكلة",
  share: "مشاركة",
  document: "أضف مستندًا",
  meterReading: "أضف قراءة",
  maintenancePlan: "إضافة خطة",
  contact: "أضف جهة اتصال",
  relationship: "اربط أصلًا",
  knowledge: "إضافة مقالة",
  move: "نقل",
  conditionReport: "تقرير الأصل",
  asset: "أضف أصلًا",
  assignAsset: "عيّن أصلًا",
  childSite: "أضف موقعًا فرعيًا",
  siteReport: "Site 360",
},
actVerbsA11y: {
  guide: "أرشدني في {{name}}",
  inspection: "بدء فحص {{name}}",
  job: "تسجيل مهمة لـ {{name}}",
  report: "الإبلاغ عن عطل في {{name}}",
  share: "مشاركة {{name}}",
  document: "إضافة مستند إلى {{name}}",
  meterReading: "تسجيل قراءة لـ {{name}}",
  maintenancePlan: "إنشاء خطة صيانة لـ {{name}}",
  contact: "إضافة جهة اتصال إلى {{name}}",
  relationship: "إضافة علاقة لـ {{name}}",
  knowledge: "إضافة معرفة إلى {{name}}",
  move: "نقل {{name}}",
  conditionReport: "إنشاء تقرير أصل لـ {{name}}",
  asset: "إضافة أصل إلى {{name}}",
  assignAsset: "تعيين أصل إلى {{name}}",
  childSite: "إضافة موقع فرعي تحت {{name}}",
  siteReport: "تقرير Site 360 لـ {{name}}",
},
actionsMenuTitle: "الإجراءات",
actionGroups: {
  help: "مساعدة",
  work: "العمل",
  record: "تسجيل",
  manage: "إدارة",
  insight: "رؤى",
},
createFabA11y: "إنشاء — {{verbs}}",
capabilityLocked: {
tryPlanFree: "جرّب {{plan}} مجانًا",
  thisFeature: "هذه الميزة",
  notInCurrentPlan: "غير مشمولة في خطتك {{plan}}",
  notInPlan: "غير مشمولة في خطتك",
  includedFrom: "مشمولة بدءًا من خطة {{plan}}",
  includedHigher: "مشمولة في خطة أعلى",
  internalEdition: "مساحة العمل هذه على إصدار Developer الداخلي. فعّل الميزة لإصدار Developer من لوحة الإدارة، Matrix.",
  noPlanIncludes: "غير متاحة في أي خطة حاليًا",
  viewPlans: "عرض الخطط",
  openBilling: "فتح الفوترة والاستخدام",
  viewPlansFor: "عرض الخطط التي تشمل {{feature}}",
  askOwner: "اطلب من مالك مساحة العمل ترقية الخطة.",
  managedOnWeb: "متاحة في خطة {{plan}} — اخترها من الفوترة والاستخدام.",
  managedOnWebUnnamed: "تُختار الخطط من الفوترة والاستخدام.",
  badge: "ترقية للاستخدام",
  betaTitle: "{{name}} في مرحلة تجريبية",
  betaDescription: "انضم إلى البرنامج التجريبي لتجربتها مبكرًا.",
  betaAction: "طلب الوصول",
  adminTitle: "{{name}} معطّلة",
  adminDescription: "إنها معطّلة لمساحة العمل هذه. تواصل مع دعم AssetWRX لتفعيلها.",
  dependencyTitle: "{{name}} تحتاج إلى ميزة أخرى",
  dependencyDescription: "ميزة تعتمد عليها معطّلة. فعّلها أولًا.",
  unavailableTitle: "{{name}} غير متاحة",
  unavailableDescription: "هذه الميزة غير متاحة لمساحة عملك.",
},
kpi: {
  of: "من",
  partial: "جزئي",
},
languageNames: {
  "ar": "العربية",
  "de-DE": "Deutsch (Deutschland)",
  "en-AU": "English (Australia)",
  "en-GB": "English (UK)",
  "en-US": "English (US)",
  "es-ES": "Español (España)",
  "fr-FR": "Français (France)",
},
createMenuTitle: "إنشاء",
detailActions: {
more: "المزيد",
moreActions: "إجراءات أخرى",
short: {
inspect: "فحص",
addJob: "مهمة",
issue: "الإبلاغ عن عطل",
share: "مشاركة",
document: "مستند",
relate: "ربط",
contact: "جهة اتصال",
insights: "الرؤى",
},
sections: {
bringWorkIn: "استقبال العمل",
doTheWork: "تنفيذ العمل",
records: "السجلات",
aiAndGuidance: "الذكاء الاصطناعي والتوجيه",
},
},
alerts: {
errorTitle: "خطأ",
requiredTitle: "مطلوب",
permissionRequiredTitle: "الإذن مطلوب",
signInRequiredTitle: "تسجيل الدخول مطلوب",
},
labels: {
id: "المعرّف",
allTypes: "جميع الأنواع",
fileSelected: "الملف المحدد",
},
search: {
defaultPlaceholder: "بحث",
clear: "مسح البحث",
},
searchableList: {
searchPlaceholder: "بحث…",
clearSearch: "مسح البحث",
all: "الكل",
remove: "إزالة {{label}}",
clear: "مسح",
noMatches: "لا توجد نتائج مطابقة.",
more_one: "نتيجة واحدة أخرى — نقّح بحثك لرؤيتها.",
more_other: "{{count}} نتيجة أخرى — نقّح بحثك لرؤيتها.",
more_zero: "لا مزيد من النتائج.",
more_two: "نتيجتان أخريان — نقّح بحثك لرؤيتهما.",
more_few: "{{count}} نتائج أخرى — نقّح بحثك لرؤيتها.",
more_many: "{{count}} نتيجة أخرى — نقّح بحثك لرؤيتها.",
},
counts: {
item_one: "{{count}} عنصر",
item_other: "{{count}} عنصر",
item_zero: "لا عناصر",
item_two: "عنصران",
item_few: "{{count}} عناصر",
item_many: "{{count}} عنصرًا",
mappedAssetsShowing_zero: "لا توجد أصول على الخريطة. أصول بلا إحداثيات مخفية: {{hidden}}.",
mappedAssetsShowing_one: "عرض أصل واحد على الخريطة. أصول بلا إحداثيات مخفية: {{hidden}}.",
mappedAssetsShowing_two: "عرض أصلين على الخريطة. أصول بلا إحداثيات مخفية: {{hidden}}.",
mappedAssetsShowing_few: "عرض {{count}} أصول على الخريطة. أصول بلا إحداثيات مخفية: {{hidden}}.",
mappedAssetsShowing_many: "عرض {{count}} أصلًا على الخريطة. أصول بلا إحداثيات مخفية: {{hidden}}.",
mappedAssetsShowing_other: "عرض {{count}} أصل على الخريطة. أصول بلا إحداثيات مخفية: {{hidden}}.",
itemsCaptureEvidence_zero: "لا يجمع أي عنصر حاليًا أي نوع من الأدلة.",
itemsCaptureEvidence_one: "عنصر واحد يجمع حاليًا نوعًا واحدًا على الأقل من الأدلة.",
itemsCaptureEvidence_two: "عنصران يجمعان حاليًا نوعًا واحدًا على الأقل من الأدلة.",
itemsCaptureEvidence_few: "{{count}} عناصر تجمع حاليًا نوعًا واحدًا على الأقل من الأدلة.",
itemsCaptureEvidence_many: "{{count}} عنصرًا يجمع حاليًا نوعًا واحدًا على الأقل من الأدلة.",
itemsCaptureEvidence_other: "{{count}} عنصر يجمع حاليًا نوعًا واحدًا على الأقل من الأدلة.",
importFileSummary: "{{file}} · {{rows}} · {{columns}}",
importRows_zero: "لا صفوف بيانات",
importRows_one: "صف بيانات واحد",
importRows_two: "صفّا بيانات",
importRows_few: "{{count}} صفوف بيانات",
importRows_many: "{{count}} صفًّا من البيانات",
importRows_other: "{{count}} صف بيانات",
importColumns_zero: "لا أعمدة",
importColumns_one: "عمود واحد",
importColumns_two: "عمودان",
importColumns_few: "{{count}} أعمدة",
importColumns_many: "{{count}} عمودًا",
importColumns_other: "{{count}} عمود",
autoMapColumns_zero: "ربط الأعمدة تلقائيًا حسب الاسم",
autoMapColumns_one: "ربط عمود واحد تلقائيًا حسب الاسم",
autoMapColumns_two: "ربط عمودين تلقائيًا حسب الاسم",
autoMapColumns_few: "ربط {{count}} أعمدة تلقائيًا حسب الاسم",
autoMapColumns_many: "ربط {{count}} عمودًا تلقائيًا حسب الاسم",
autoMapColumns_other: "ربط {{count}} عمود تلقائيًا حسب الاسم",
importPreviewRows_zero: "أول {{shown}} من أصل {{count}} صف. تعرض الصفوف الصالحة القيم نفسها التي ستُستورد؛ وتعرض الصفوف غير الصالحة الأخطاء مع قيم الخلايا التي قرأناها.",
importPreviewRows_one: "أول {{shown}} من أصل صف واحد. تعرض الصفوف الصالحة القيم نفسها التي ستُستورد؛ وتعرض الصفوف غير الصالحة الأخطاء مع قيم الخلايا التي قرأناها.",
importPreviewRows_two: "أول {{shown}} من أصل صفين. تعرض الصفوف الصالحة القيم نفسها التي ستُستورد؛ وتعرض الصفوف غير الصالحة الأخطاء مع قيم الخلايا التي قرأناها.",
importPreviewRows_few: "أول {{shown}} من أصل {{count}} صفوف. تعرض الصفوف الصالحة القيم نفسها التي ستُستورد؛ وتعرض الصفوف غير الصالحة الأخطاء مع قيم الخلايا التي قرأناها.",
importPreviewRows_many: "أول {{shown}} من أصل {{count}} صفًّا. تعرض الصفوف الصالحة القيم نفسها التي ستُستورد؛ وتعرض الصفوف غير الصالحة الأخطاء مع قيم الخلايا التي قرأناها.",
importPreviewRows_other: "أول {{shown}} من أصل {{count}} صف. تعرض الصفوف الصالحة القيم نفسها التي ستُستورد؛ وتعرض الصفوف غير الصالحة الأخطاء مع قيم الخلايا التي قرأناها.",
applyRows_zero: "لا صفوف للتطبيق",
applyRows_one: "تطبيق صف واحد",
applyRows_two: "تطبيق صفين",
applyRows_few: "تطبيق {{count}} صفوف",
applyRows_many: "تطبيق {{count}} صفًّا",
applyRows_other: "تطبيق {{count}} صف",
automationsReady_zero: "لا توجد عمليات أتمتة جاهزة",
automationsReady_one: "عملية أتمتة واحدة جاهزة",
automationsReady_two: "عمليتا أتمتة جاهزتان",
automationsReady_few: "{{count}} عمليات أتمتة جاهزة",
automationsReady_many: "{{count}} عملية أتمتة جاهزة",
automationsReady_other: "{{count}} عملية أتمتة جاهزة",
aiFollowUpsReady_zero: "لا توجد متابعات جاهزة أعدّها الذكاء الاصطناعي",
aiFollowUpsReady_one: "متابعة واحدة أعدّها الذكاء الاصطناعي جاهزة",
aiFollowUpsReady_two: "متابعتان أعدّهما الذكاء الاصطناعي جاهزتان",
aiFollowUpsReady_few: "{{count}} متابعات أعدّها الذكاء الاصطناعي جاهزة",
aiFollowUpsReady_many: "{{count}} متابعةً أعدّها الذكاء الاصطناعي جاهزة",
aiFollowUpsReady_other: "{{count}} متابعة أعدّها الذكاء الاصطناعي جاهزة",
extractedItemsFound_zero: "لم يتم العثور على أي بند.",
extractedItemsFound_one: "تم العثور على بند واحد. عدّله أو ألغِ تحديده قبل إضافته إلى المهمة.",
extractedItemsFound_two: "تم العثور على بندين. عدّلهما أو ألغِ تحديدهما قبل إضافتهما إلى المهمة.",
extractedItemsFound_few: "تم العثور على {{count}} بنود. عدّلها أو ألغِ تحديدها قبل إضافتها إلى المهمة.",
extractedItemsFound_many: "تم العثور على {{count}} بندًا. عدّلها أو ألغِ تحديدها قبل إضافتها إلى المهمة.",
extractedItemsFound_other: "تم العثور على {{count}} بند. عدّلها أو ألغِ تحديدها قبل إضافتها إلى المهمة.",
addItems_zero: "لا بنود للإضافة",
addItems_one: "إضافة بند واحد",
addItems_two: "إضافة بندين",
addItems_few: "إضافة {{count}} بنود",
addItems_many: "إضافة {{count}} بندًا",
addItems_other: "إضافة {{count}} بند",
},
teamMemberRole: {
owner: "المالك",
admin: "المسؤول",
member: "عضو",
},
teamSummary: {
memberCount_zero: "لا أعضاء",
memberCount_one: "عضو واحد",
memberCount_two: "عضوان",
memberCount_few: "{{count}} أعضاء",
memberCount_many: "{{count}} عضوًا",
memberCount_other: "{{count}} عضو",
pendingInvites_zero: "لا دعوات معلّقة",
pendingInvites_one: "دعوة معلّقة واحدة",
pendingInvites_two: "دعوتان معلّقتان",
pendingInvites_few: "{{count}} دعوات معلّقة",
pendingInvites_many: "{{count}} دعوة معلّقة",
pendingInvites_other: "{{count}} دعوة معلّقة",
expiredInvites_zero: "لا دعوات منتهية",
expiredInvites_one: "دعوة منتهية واحدة",
expiredInvites_two: "دعوتان منتهيتان",
expiredInvites_few: "{{count}} دعوات منتهية",
expiredInvites_many: "{{count}} دعوة منتهية",
expiredInvites_other: "{{count}} دعوة منتهية",
twoFactorOn: "المصادقة الثنائية مفعّلة",
twoFactorOff: "المصادقة الثنائية غير مفعّلة",
youSuffix: "(أنت)",
skillsLoading: "المهارات: جارٍ التحميل…",
noSkills: "لا مهارات مسجّلة — اضغط للإضافة",
skillCount_zero: "لا مهارات",
skillCount_one: "مهارة واحدة",
skillCount_two: "مهارتان",
skillCount_few: "{{count}} مهارات",
skillCount_many: "{{count}} مهارة",
skillCount_other: "{{count}} مهارة",
editSkillsA11y: "تعديل مهارات {{name}}",
},
teamMemberAction: {
askAdmin: "طلب تعيينه مسؤولاً",
changeToAdmin: "تغيير إلى مسؤول",
changeToMember: "تغيير إلى عضو",
requestSentTitle: "تم إرسال الطلب",
requestSentBody: "سيُطلب من مالك الفريق الموافقة على تعيين {{name}} مسؤولاً.",
roleChangeFailed: "تعذّر تغيير الدور",
removeFailed: "تعذّرت إزالة العضو",
decideFailed: "تعذّر حفظ قرارك",
pendingTitle: "بانتظار موافقتك",
pendingTitleAdmin: "بانتظار المالك",
pendingRow: "تعيين {{name}} مسؤولاً؟ بطلب من {{requester}}.",
approve: "موافقة",
decline: "رفض",
requestedPill: "طُلب تعيينه مسؤولاً",
},
embedNotice: {
  viewOnly: "للعرض فقط: تتيح لك هذه البوابة الاطلاع على السجلات دون تغييرها.",
  loading: "جارٍ فتح AssetWRX…",
  reload: "إعادة تحميل الصفحة",
  expiredBody: "استغرق تسجيل الدخول وقتًا أطول مما تسمح به هذه الصفحة. أعد تحميل الصفحة وستدخل مباشرة.",
  expiredTitle: "أعد التحميل للمتابعة",
pageTitle: "العرض المُضمَّن",
unsupportedTitle: "غير متاح هنا",
unsupportedBody: "هذا الجزء من AssetWRX غير مضمّن في هذا العرض المُضمَّن.",
goBack: "رجوع",
openInAssetWrx: "فتح في AssetWRX",
unavailableTitle: "التضمين متوقف",
unavailableBody: "AssetWRX المضمّن غير متاح في خطة مساحة العمل هذه. اطلب من مالك مساحة عمل AssetWRX تغيير الخطة.",
deniedTitle: "تعذّر فتح هذا العرض",
deniedBody: "لا يُسمح لهذه البوابة بفتح AssetWRX لك هنا. اطلب من مسؤول AssetWRX مراجعة التطبيق المُضمَّن.",
endedTitle: "انتهت الجلسة",
endedBody: "انتهت جلسة AssetWRX المُضمَّنة هذه. أعد تحميل الصفحة لبدء جلسة جديدة.",
sessionRequiredTitle: "افتحه من بوابتك",
sessionRequiredBody: "لا يمكن عرض هذه الصفحة من AssetWRX إلا من خلال بوابة معتمدة. افتحها من هناك.",
ssoDeniedTitle: "استخدم حساب مؤسستك",
ssoDeniedBody: "تتطلب هذه البوابة تسجيل الدخول بحساب Microsoft الخاص بمؤسستك. أعد تحميل الصفحة للمحاولة مرة أخرى.",
},
tourStep: "الخطوة {{current}} من {{total}}",
guideFlow: {
  pages: {
    assets: "الأصول",
    inspections: "الفحوصات",
    requests: "الطلبات",
    jobs: "المهام",
    reports: "التقارير",
    contacts: "جهات الاتصال",
    contractors: "المقاولون",
  },
  ui: {
    open: "فتح {{page}}",
    howItWorks: "كيف يعمل",
    comesInFrom: "يصل من",
    feeds: "يغذّي {{stage}}",
    tapAgain: "اضغط مرة أخرى للفتح.",
    subtitle: "الدورة اليومية من البداية إلى النهاية. مرّر المؤشر أو اضغط على مرحلة، ثم افتح صفحتها.",
    stageA11y: "{{num}}. {{label}}. {{caption}}. يفتح {{page}}.",
    inputA11y: "{{label}}. يغذّي {{stage}}. يفتح {{page}}.",
  },
  "add-your-first-asset": {
    label: "إضافة الأصول",
    caption: "سجّل ما تملكه",
  },
  "run-an-inspection": {
    label: "الفحص",
    caption: "تحقّق من الحالة والأدلة",
  },
  "report-an-issue": {
    label: "الإبلاغ عن المشكلات",
    caption: "يمكن لأي شخص الإبلاغ",
  },
  "create-a-job": {
    label: "تنفيذ العمل",
    caption: "كلّف بالمهام وتابعها",
  },
  "share-a-report": {
    label: "المراجعة والمشاركة",
    caption: "أكمل الدورة حتى النهاية",
  },
  "public-intake-qr": {
    label: "بلاغات QR العامة",
  },
  "share-for-requests": {
    label: "مقدّمو طلبات مشتركون",
  },
  "add-a-contractor": {
    label: "المقاولون",
  },
},
notFound: {
stackTitle: "غير موجود",
title: "الصفحة غير موجودة",
goHome: "الانتقال إلى الرئيسية",
body: "ربما يكون الرابط قديمًا أو نُقلت الصفحة.",
},
compact: {
  minutes: "{{n}} د",
  hours: "{{n}} س",
  days: "{{n}} ي",
  now: "الآن",
  justNow: "قبل لحظات",
  yesterday: "أمس",
  tomorrow: "غدًا",
},
relative: {
  today: "اليوم",
  tomorrow: "غدًا",
  daysAgo: "منذ {{n}} ي",
  yesterday: "أمس",
  hoursAgo: "منذ {{n}} س",
  minutesAgo: "منذ {{n}} د",
  justNow: "الآن",
deadlinePassed: "انتهى الموعد",
daysLeft_one: "تبقى {{count}} يوم",
daysLeft_other: "تبقى {{count}} يوم",
hoursLeft_one: "تبقى {{count}} ساعة",
hoursLeft_other: "تبقى {{count}} ساعة",
minutesLeft_one: "تبقى {{count}} دقيقة",
minutesLeft_other: "تبقى {{count}} دقيقة",
daysLeft_zero: "لا أيام متبقية",
daysLeft_two: "يومان متبقيان",
daysLeft_few: "تبقى {{count}} أيام",
daysLeft_many: "تبقى {{count}} يومًا",
hoursLeft_zero: "لا ساعات متبقية",
hoursLeft_two: "تبقى ساعتان",
hoursLeft_few: "تبقى {{count}} ساعات",
hoursLeft_many: "تبقى {{count}} ساعة",
minutesLeft_zero: "لا دقائق متبقية",
minutesLeft_two: "تبقى دقيقتان",
minutesLeft_few: "تبقى {{count}} دقائق",
minutesLeft_many: "تبقى {{count}} دقيقة",
},
errors: {
  unreachable: "تعذّر الوصول إلى الخادم. تأكد من أنك متصل بالإنترنت، ثم حاول مرة أخرى.",
  notThrough: "لم تكتمل العملية. يُرجى المحاولة مرة أخرى.",
  workspaceUnavailable: "تعذّر تحميل مساحة عملك. تأكد من أنك متصل بالإنترنت، ثم حاول مرة أخرى.",
  summaryAuthorOnly: "يمكن للشخص الذي أجرى هذا الفحص، أو لمسؤول مساحة العمل، فقط تغيير ملخصه، وذلك قبل اعتماده فقط.",
  assetNotEditable: "لا يمكنك تغيير أحد هذه الأصول.",
  templateNotEditable: "لا يمكنك تغيير الأشخاص الذين تتم مشاركة هذا قائمة التحقق معهم.",
  deleteApproved: "لا يمكن حذف فحص معتمد؛ فهو جزء من سجل الامتثال.",
  cancelApproved: "لا يمكن إلغاء فحص معتمد.",
  requiredItemsIncomplete: "يحتاج كل بند مطلوب إلى إجابة أو تخطٍّ قبل إكمال هذا الفحص.",
  quoteRequestClosed: "طلب عرض السعر هذا مغلق. فقد تمت ترسيته أو انتهت مهلته أو تم سحبه.",
  postcheckRequired: "يجب إكمال فحص مطلوب قبل إرسال هذه المهمة.",
  evidenceRequired: "مطلوب صورة أو فيديو للعمل المنجز. أضفه إلى هذه المهمة أو إلى إحدى مهامها الفرعية، ثم حاول مرة أخرى.",
  precheckRequired: "يجب إكمال الفحص المسبق قبل بدء هذه المهمة.",
  jobHandedOff: "تم تسليم هذه المهمة إلى شخص آخر. أعد إسنادها أو استرجعها لتغييرها.",
  jobOutForQuotes: "هذه المهمة لدى المقاولين لتقديم عروض الأسعار. اختر عرضًا أو أغلق الطلب لتغييرها.",
  inspectionHandedOff: "تم تسليم هذا الفحص إلى شخص آخر. هو وحده من يمكنه الإجابة عليه.",
  retireOpenWork: "لا يزال لهذا الأصل عمل قيد التنفيذ. أكمله أو ألغِه قبل إخراج الأصل من الخدمة نهائيًا.",
  templateInUseBySchedules: "لا يزال هذا قائمة التحقق مستخدمًا في فحوصات مجدولة قادمة. ألغِ تلك الجداول أولاً.",
  approveOverseerOnly: "يمكن لمالك الأصل أو المعتمِد أو الفريق فقط اعتماد هذا الفحص، ولا يمكن للمفتش اعتماد عمله بنفسه.",
  waiverAdminOnly: "يمكن لمسؤول مساحة العمل فقط التنازل عن ملاحظة.",
  restoreAdminOnly: "يمكن لمسؤول مساحة العمل فقط استعادة أصل موقوف عن الخدمة.",
  retireOwnerOrAdmin: "يمكن لمالك الأصل أو مسؤول مساحة العمل فقط إخراجه من الخدمة نهائيًا.",
  assetRetired: "أُخرج هذا الأصل من الخدمة نهائيًا ولا يقبل فحوصات أو مهام جديدة.",
  workspaceReadOnly: "مساحة العمل هذه للقراءة فقط. اختر خطة من الفوترة لمواصلة الإضافة والتعديل.",
  assetPlanLimit: "وصلت إلى حد الأصول في خطتك. تتيح خطة أكبر إضافة المزيد من الأصول.",
  capabilityUnavailable: "هذه الميزة غير مضمّنة في خطتك. اختر خطة من الفوترة لاستخدامها.",
  assetSubscriptionRequired: "استخدمت مساحة عملك الأصول المجانية في خطتها. ابدأ اشتراكًا لإضافة المزيد من الأصول.",
  assetChanged: "تغيّر هذا الأصل منذ أن فتحته. أعد تحميله وحاول مرة أخرى.",
  onlineRequired: "أعد الاتصال لإكمال هذا الإجراء. ستبقى المعلومات التي أدخلتها هنا.",
  jobUpdateRefused: "تعذّر تحديث هذه المهمة من حسابك. ربما أُعيد تعيينها أو أُغلقت. حدّث الصفحة وحاول مرة أخرى.",
  jobChanged: "تغيّرت هذه المهمة منذ أن فتحتها. أعد تحميلها وحاول مرة أخرى.",
  sessionExpired: "انتهت صلاحية جلستك. يُرجى تسجيل الدخول مرة أخرى.",
  alreadyExists: "هذا العنصر موجود بالفعل. استخدم قيمة مختلفة أو حدّث العنصر الموجود.",
  configMismatch: "تعذّر على التطبيق إكمال هذا الإجراء. حاول مرة أخرى، أو تواصل مع الدعم إذا تكرر ذلك.",
  valueNotAllowed: "إحدى القيم غير مسموح بها. تحقّق مما أدخلته وحاول مرة أخرى.",
  network: "الاتصال بطيء أو منقطع. يُرجى المحاولة مرة أخرى.",
  requiredMissing: "أحد الحقول المطلوبة فارغ. يُرجى تعبئة جميع المعلومات المطلوبة.",
  noPermission: "ليس لديك إذن للقيام بذلك.",
  missingReference: "تمت إزالة عنصر يحتاجه هذا الإجراء. حدّث الصفحة وحاول مرة أخرى.",
  notFound: "تعذّر العثور على هذا العنصر. ربما تمت إزالته.",
  fallback: "حدث خطأ ما. يُرجى المحاولة مرة أخرى.",
generic: "حدث خطأ ما.",
},
resilience: {
capability_disabled: {
title: "هذه الإمكانية غير متاحة",
body: "لم تفعّل مؤسستك هذه الإمكانية. تواصل مع المسؤول إذا كنت بحاجة إلى الوصول.",
},
permission_denied: {
title: "ليس لديك إذن",
body: "لا يسمح دورك الحالي بتنفيذ هذا الإجراء. لم يتم تغيير عملك الحالي.",
},
read_only: {
title: "وصول للقراءة فقط",
body: "يمكنك عرض هذه المعلومات، لكن دورك الحالي لا يسمح بتغييرها.",
},
resource_unavailable: {
title: "لم يعد هذا العنصر متاحًا",
body: "ربما تمت إزالته أو تغير وصولك. افتح النشاط للمتابعة بأمان.",
action: "فتح النشاط",
},
online_required: {
title: "يلزم اتصال بالإنترنت",
body: "أعد الاتصال وحاول مرة أخرى. ستظل المعلومات التي أدخلتها متاحة على هذا الجهاز.",
},
},
sorting: {
sortBy: "الترتيب حسب",
newest: "الأحدث أولاً",
oldest: "الأقدم أولاً",
last_updated: "آخر تحديث",
name_az: "الاسم أ–ي",
name_za: "الاسم ي–أ",
priority_high: "الأولوية من الأعلى إلى الأدنى",
priority_low: "الأولوية من الأدنى إلى الأعلى",
due_soonest: "الأقرب استحقاقاً",
due_latest: "الأبعد استحقاقاً",
overdue_first: "المتأخرة أولاً",
recently_active: "النشطة مؤخراً",
status: "الحالة",
condition_score: "درجة الحالة",
health_score: "درجة الصحة",
risk_score: "درجة المخاطر",
compliance_score: "درجة الامتثال",
last_inspection: "تاريخ آخر فحص",
completed_date: "تاريخ الإكمال",
assigned_to: "مُسند إلى",
scheduled_date: "التاريخ المجدول",
inspection_score: "درجة الفحص",
requested_date: "تاريخ الطلب",
approval_status: "حالة الموافقة",
},
scanCapture: {
openSettings: "فتح الإعدادات",
cameraBlockedMessage: "الوصول إلى الكاميرا متوقف لتطبيق AssetWRX. فعّله من الإعدادات أو استخدم صورة بدلاً من ذلك.",
signInRequiredBody: "يرجى تسجيل الدخول لقراءة صورة باستخدام الذكاء الاصطناعي.",
aiOfflineStatus: "ستتوفر القراءة بالذكاء الاصطناعي عند عودتك إلى الاتصال بالإنترنت. صورتك لا تزال هنا.",
readingWithAiStatus: "جارٍ قراءة الصورة باستخدام الذكاء الاصطناعي…",
couldNotReadPhotoTitle: "تعذر قراءة الصورة",
tryAgain: "حاول مرة أخرى.",
noIdentifierReadable: "لم يكن رقم VIN أو الرقم التسلسلي مقروءًا في تلك الصورة. حاول مرة أخرى أو أدخله يدويًا.",
permissionRequiredTitle: "الإذن مطلوب",
grantLibraryBody: "يرجى منح حق الوصول إلى مكتبة الصور.",
readingPhotoStatus: "جارٍ قراءة الصورة…",
couldNotReadOnDeviceWeb: "أدخل القيمة أدناه، أو اقرأ الصورة باستخدام الذكاء الاصطناعي.",
couldNotReadOnDeviceNative: "تعذر قراءتها على هذا الجهاز. أدخل القيمة أدناه، أو اقرأ الصورة باستخدام الذكاء الاصطناعي.",
enterAValueTitle: "أدخل قيمة",
enterAValueBody: "الرجاء لصق أو كتابة قيمة.",
readWithAiLabel: "اقرأ الصورة باستخدام الذكاء الاصطناعي. التكلفة: {{cost}}.",
readWithAiText: "القراءة باستخدام الذكاء الاصطناعي ({{cost}})",
scanQrTitle: "مسح رمز QR",
scanIdentifierTitle: "مسح VIN / الرقم التسلسلي",
webUnavailableMessage: "المسح بالكاميرا غير متاح على الويب. الصق قيمة، أو اختر صورة للملصق لقراءتها.",
identifierInputLabel: "VIN أو الرقم التسلسلي",
identifierPlaceholder: "الصق أو اكتب VIN / الرقم التسلسلي…",
useThisValue: "استخدم هذه القيمة",
pickPhotoOfLabel: "اختر صورة للملصق",
requestingCameraPermission: "جارٍ طلب إذن الكاميرا…",
cameraPermissionRequiredTitle: "إذن الكاميرا مطلوب",
cameraPermissionMessage: "يلزم الوصول إلى الكاميرا لإجراء المسح الضوئي. يمكنك أيضًا قراءة الملصق من صورة محفوظة.",
grantPermission: "منح الإذن",
usePhotoInstead: "استخدم صورة بدلاً من ذلك",
closeScanner: "إغلاق الماسح الضوئي",
readingEllipsis: "جارٍ القراءة…",
positionQrHint: "ضع كود QR في الإطار",
positionBarcodeHint: "أشر إلى الرمز الشريطي، أو اضغط زر الالتقاط لقراءة الملصق من صورة",
takePhotoOfLabel: "التقط صورة للملصق",
photo: "صورة",
library: "المكتبة",
holdStill: "ثبّت الهاتف…",
glareHint: "يوجد وهج على اللوحة — أمِل الهاتف قليلًا أو ظلّل اللوحة، ثم حاول مرة أخرى.",
darkHint: "الإضاءة خافتة جدًا للقراءة — شغّل الضوء أو انتقل إلى إضاءة أفضل، ثم حاول مرة أخرى.",
},
cameraControls: {
noZoom: "1×",
zoomPercent: "{{percent}}٪",
zoomOut: "تصغير",
zoomIn: "تكبير",
resetZoom: "إعادة ضبط التكبير",
zoomValueA11y: "التكبير {{percent}} بالمئة",
lightOn: "تشغيل الضوء",
lightOff: "إيقاف الضوء",
},
cookieBanner: {
title: "ملفات تعريف الارتباط على AssetWRX",
bodyBeforeLink: "نستخدم ملفات تعريف الارتباط الضرورية بشكل أساسي لتشغيل AssetWRX. وبموافقتك، سنستخدم أيضًا ملفات تعريف الارتباط لفهم كيفية استخدام التطبيق ولقياس الحملات التسويقية. يمكنك تغيير رأيك في أي وقت من",
bodyCompact: "ملفات تعريف الارتباط الضرورية فقط، ما لم تسمح بملفات التحليلات والتسويق. التفاصيل في",
cookiePolicyLink: "سياسة ملفات تعريف الارتباط",
rejectAll: "رفض الكل",
managePreferences: "إدارة التفضيلات",
acceptAll: "قبول الكل",
preferencesTitle: "تفضيلات ملفات تعريف الارتباط",
strictlyNecessaryTitle: "ضروري للغاية",
alwaysOn: "قيد التشغيل دائمًا",
strictlyNecessaryBody: "تسجيل الدخول والأمان والوظائف الأساسية.",
analyticsTitle: "التحليلات",
analyticsBody: "أحداث الاستخدام المجهولة التي تساعدنا على تحسين AssetWRX.",
marketingTitle: "تسويق",
marketingBody: "قياس أداء الحملة. نحن لا نبيع بياناتك أبدًا.",
back: "رجوع",
savePreferences: "حفظ التفضيلات",
},
analyticsPrompt: {
title: "ساعدنا في تحسين AssetWRX",
body: "شارك بيانات الاستخدام (الشاشات التي تستخدمها ونقراتك، وليس ما تكتبه أبدًا) لنجعل التطبيق أسرع وأسهل. يمكنك تغيير ذلك في أي وقت من الحساب ← الخصوصية والبيانات ← تفضيلات التواصل.",
allow: "السماح",
notNow: "ليس الآن",
},
webContactsList: {
sort: {
name_asc: "الاسم أ–ي",
name_desc: "الاسم ي–أ",
updated_desc: "آخر تحديث",
},
allRoles: "الكل",
filterByRoleA11y: "تصفية جهات الاتصال حسب الدور",
roleA11y: "الدور: {{role}}",
moreFiltersA11y: "المزيد من المرشحات: جميع أنواع الأدوار وإعادة التعيين",
more: "المزيد…",
visibilityScopeA11y: "نطاق الرؤية",
scopeAllA11y: "النطاق: الكل",
scopeTeamA11y: "النطاق: فريق",
scopeAccountA11y: "النطاق: الحساب",
scopeAllLabel: "جميع النطاقات",
scopeTeamLabel: "فريق",
scopeAccountLabel: "الحساب",
sortContactsA11y: "فرز جهات الاتصال",
sortA11y: "الترتيب: {{sort}}",
importContactsA11y: "استيراد جهات الاتصال",
import: "استيراد",
columns: {
name: "الاسم",
scope: "النطاق",
roles: "الأدوار",
organisation: "مؤسسة",
contact: "البريد الإلكتروني / الهاتف",
skills: "المهارات",
},
},
qrLabelPrint: {
defaultTitle: "طباعة ملصقات QR",
noAssetsTitle: "لا توجد أصول",
noAssetsBody: "حدد أصلًا واحدًا على الأقل لطباعة الملصقات.",
noQrCodesTitle: "لا توجد رموز QR",
noQrCodesBody: "الأصول المحددة لا تحتوي على رموز QR حتى الآن.",
labelsPrepared_one: "تم إعداد ملصق واحد.",
labelsPrepared_other: "تم إعداد {{count}} ملصق.",
assetsSkipped_one: "تم تخطي أصل واحد (رمز QR مفقود).",
assetsSkipped_other: "تم تخطي {{count}} أصل (رمز QR مفقود).",
labelsUsedFallback_one: "استخدم ملصق واحد رمز AssetWRX (لا يوجد رقم تسلسلي مسجل).",
labelsUsedFallback_other: "استخدم {{count}} ملصق رمز AssetWRX (لا يوجد رقم تسلسلي مسجل).",
labelsReadyTitle: "الملصقات جاهزة",
printFailedTitle: "فشلت الطباعة",
printFailedBody: "تعذّر إنشاء الملصقات.",
selectedAssetsLabel: "الأصول المختارة",
selectedAssetsValue_zero: "تم تحديد {{count}} ({{withQr}} برمز QR)",
selectedAssetsValue_one: "تم تحديد {{count}} ({{withQr}} برمز QR)",
selectedAssetsValue_two: "تم تحديد {{count}} ({{withQr}} برمز QR)",
selectedAssetsValue_few: "تم تحديد {{count}} ({{withQr}} برمز QR)",
selectedAssetsValue_many: "تم تحديد {{count}} ({{withQr}} برمز QR)",
selectedAssetsValue_other: "تم تحديد {{count}} ({{withQr}} برمز QR)",
templateLabel: "قائمة التحقق",
qrContentsLabel: "محتويات QR",
serialCoverageNote: "{{withSerial}} من {{total}} لديها رقم تسلسلي؛ ويُستخدم رمز AssetWRX للباقي.",
scanActionLabel: "إجراء المسح",
includeMetadataToggle: "تضمين بيانات وصفية مختصرة على الملصقات",
cancel: "إلغاء",
printLabels: "طباعة الملصقات",
labelsPrepared_zero: "لم يُعدّ أي ملصق.",
labelsPrepared_two: "تم إعداد ملصقين.",
labelsPrepared_few: "تم إعداد {{count}} ملصقات.",
labelsPrepared_many: "تم إعداد {{count}} ملصقًا.",
assetsSkipped_zero: "لم يُتخطَّ أي أصل (رمز QR مفقود).",
assetsSkipped_two: "تم تخطي أصلين (رمز QR مفقود).",
assetsSkipped_few: "تم تخطي {{count}} أصول (رمز QR مفقود).",
assetsSkipped_many: "تم تخطي {{count}} أصلًا (رمز QR مفقود).",
labelsUsedFallback_zero: "لم يستخدم أي ملصق رمز AssetWRX (لا يوجد رقم تسلسلي مسجل).",
labelsUsedFallback_two: "استخدم ملصقان رمز AssetWRX (لا يوجد رقم تسلسلي مسجل).",
labelsUsedFallback_few: "استخدمت {{count}} ملصقات رمز AssetWRX (لا يوجد رقم تسلسلي مسجل).",
labelsUsedFallback_many: "استخدم {{count}} ملصقًا رمز AssetWRX (لا يوجد رقم تسلسلي مسجل).",
},
reportReview: {
  stillToDecide_other: "ما زال {{count}} بند يحتاج إلى قرار. اقرأ النتائج أدناه، ثم قرر من قراراتك في الأعلى.",
  stillToDecide_many: "ما زال {{count}} بندًا يحتاج إلى قرار. اقرأ النتائج أدناه، ثم قرر من قراراتك في الأعلى.",
  stillToDecide_few: "ما زالت {{count}} بنود تحتاج إلى قرار. اقرأ النتائج أدناه، ثم قرر من قراراتك في الأعلى.",
  stillToDecide_two: "ما زال بندان يحتاجان إلى قرار. اقرأ النتائج أدناه، ثم قرر من قراراتك في الأعلى.",
  stillToDecide_one: "ما زال بند واحد يحتاج إلى قرار. اقرأ النتائج أدناه، ثم قرر من قراراتك في الأعلى.",
  stillToDecide_zero: "لا بنود بلا قرار.",
  gate: {
    notYouBody: "أخبرنا بعلاقتك بهذا الأصل. يقرر الفريق المسؤول عنه ما إذا كان بإمكانك رؤية التقرير.",
    notYouLink: "لست الشخص الذي أُرسل إليه؟ اطلب الوصول",
    useDifferentAccount: "استخدام حساب آخر",
    signedInAs: "مسجّل الدخول باسم {{email}}. أُرسل هذا التقرير إلى بريد إلكتروني آخر.",
    notYouSignedOut: "لست الشخص الذي أُرسل إليه؟ سجّل الدخول، ثم اضغط طلب الوصول.",
    signedOutBody: "هل أُرسل إليك؟ سجّل الدخول بالبريد الإلكتروني الذي أُرسل إليه وسيُفتح مباشرةً.",
    requestAccess: "طلب الوصول",
    sendFailedTitle: "تعذر إرسال الطلب",
    roleManager: "مدير العقار أو الوكيل",
    outcomeClear: "لا توجد مشكلات",
    outcomeAttention: "يحتاج إلى انتباه",
    outcomeAction: "يتطلب إجراء",
    askSender: "اطلب من الشخص الذي أرسله إعادة إرسال الرابط.",
  },
  jobs: {
    count_other: "{{count}} مهمة",
    count_many: "{{count}} مهمة",
    count_few: "{{count}} مهام",
    count_two: "مهمتان",
    count_one: "مهمة واحدة",
    count_zero: "لا مهام",
    estimatedCost: "التقدير: {{amount}}",
    approvedCost: "المعتمد: {{amount}}",
    started: "بدأت في {{date}}",
    scheduled: "مجدولة في {{date}}",
    assignedTo: "مُسندة إلى {{name}}",
    cancelled: "ملغاة: {{n}}",
    inProgress: "قيد التنفيذ: {{n}}",
    completed: "مكتملة: {{n}}",
  },
  done: {
    senderRepairs_other: "تمت الموافقة على {{count}} إصلاح. اضغط إنشاء مهام في الفحص لجدولتها.",
    senderRepairs_many: "تمت الموافقة على {{count}} إصلاحًا. اضغط إنشاء مهام في الفحص لجدولتها.",
    senderRepairs_few: "تمت الموافقة على {{count}} إصلاحات. اضغط إنشاء مهام في الفحص لجدولتها.",
    senderRepairs_two: "تمت الموافقة على إصلاحين. اضغط إنشاء مهام في الفحص لجدولتهما.",
    senderRepairs_one: "تمت الموافقة على إصلاح واحد. اضغط إنشاء مهام في الفحص لجدولته.",
    senderRepairs_zero: "لا إصلاحات معتمدة.",
    repairsApproved_other: "وافقت على {{count}} إصلاح. يُبلَّغ الفريق ويمكنه تحويلها إلى مهام.",
    repairsApproved_many: "وافقت على {{count}} إصلاحًا. يُبلَّغ الفريق ويمكنه تحويلها إلى مهام.",
    repairsApproved_few: "وافقت على {{count}} إصلاحات. يُبلَّغ الفريق ويمكنه تحويلها إلى مهام.",
    repairsApproved_two: "وافقت على إصلاحين. يُبلَّغ الفريق ويمكنه تحويلهما إلى مهام.",
    repairsApproved_one: "وافقت على إصلاح واحد. يُبلَّغ الفريق ويمكنه تحويله إلى مهمة.",
    repairsApproved_zero: "لم توافق على أي إصلاح.",
    allMarked: "تم تعليم كل البنود بالموافقة. ارفض ما لا تريده، ثم وقّع واضغط موافقة.",
    changesRequested: "طلبت تعديلات. وصلت ملاحظتك إلى {{company}}.",
    allDeclined: "وافقت على التقرير ورفضت كل الإصلاحات. لدى الفريق ملاحظاتك.",
    approved: "وافقت على هذا التقرير. تم إبلاغ الفريق.",
  },
  signOff: {
    decideFirst_other: "قرر في كل بند أولاً (بقي {{count}} بند)",
    decideFirst_many: "قرر في كل بند أولاً (بقي {{count}} بندًا)",
    decideFirst_few: "قرر في كل بند أولاً (بقيت {{count}} بنود)",
    decideFirst_two: "قرر في كل بند أولاً (بقي بندان)",
    decideFirst_one: "قرر في كل بند أولاً (بقي بند واحد)",
    decideFirst_zero: "قرر في كل بند أولاً",
    sendBackPlaceholder: "ما الذي يجب تغييره؟ (مطلوب)",
    sendBack: "إرجاع",
    promptDecideFirst: "اضغط أولاً موافقة أو رفض لكل بند في الأعلى. يمكنك الضغط على إرجاع في أي وقت.",
    promptReady: "وقّع للاعتماد. يُبلَّغ الفريق ويمكنه تحويل الإصلاحات التي وافقت عليها إلى مهام.",
    promptNoItems: "اقرأ التقرير. ثم وقّع للاعتماد، أو اضغط إرجاع لطلب تعديلات.",
    sendToTeam: "إرسال إلى الفريق",
    signatureLabel: "وقّع هنا",
    recordsOnly: "هذا التقرير لسجلاتك.",
    changesMessage: "لقد طلبت تعديلات",
    approvedMessage: "لقد وافقت على هذا. شكرًا لك.",
    changesPlaceholder: "ما الذي يحتاج إلى مزيد من العمل؟",
    requestChanges: "طلب تعديلات",
    approve: "اعتماد",
    prompt: "راجع العمل، ثم وافق عليه أو اطلب تعديلات.",
    title: "قرارك",
  },
  insight: {
    itemsIncluded_other: "{{count}} بند في هذا التقرير.",
    itemsIncluded_many: "{{count}} بندًا في هذا التقرير.",
    itemsIncluded_few: "{{count}} بنود في هذا التقرير.",
    itemsIncluded_two: "بندان في هذا التقرير.",
    itemsIncluded_one: "بند واحد في هذا التقرير.",
    itemsIncluded_zero: "لا بنود في هذا التقرير.",
    senderWaitingItems_other: "بانتظار قرار {{name}} بشأن {{count}} بند.",
    senderWaitingItems_many: "بانتظار قرار {{name}} بشأن {{count}} بندًا.",
    senderWaitingItems_few: "بانتظار قرار {{name}} بشأن {{count}} بنود.",
    senderWaitingItems_two: "بانتظار قرار {{name}} بشأن بندين.",
    senderWaitingItems_one: "بانتظار قرار {{name}} بشأن بند واحد.",
    senderWaitingItems_zero: "بانتظار {{name}}.",
    toDecide_other: "{{count}} بند ينتظر قرارك قبل الموافقة.",
    toDecide_many: "{{count}} بندًا ينتظر قرارك قبل الموافقة.",
    toDecide_few: "{{count}} بنود تنتظر قرارك قبل الموافقة.",
    toDecide_two: "بندان ينتظران قرارك قبل الموافقة.",
    toDecide_one: "بند واحد ينتظر قرارك قبل الموافقة.",
    toDecide_zero: "لا بنود تنتظر قرارك.",
    sourceLabel: "بنود هذا التقرير",
    actionSenderWait: "يتلقى مُرسِل التقرير إشعارًا عند الرد.",
    actionTrackJobs: "تابع المهام المنشأة من هذا التقرير أدناه.",
    actionApprove: "وقّع ثم اضغط موافقة. يُبلَّغ الفريق فورًا.",
    actionDecide: "اضغط موافقة أو رفض لكل بند.",
    metricNotDecided: "بلا قرار",
    metricToDecide: "للبت فيها",
    checkFirst: "تحقق قبل أن تقرر: {{list}}.",
    duplicates: "تكرارات محتملة: {{n}}",
    noPhotos: "بلا صور: {{n}}",
    urgent: "عاجلة: {{n}}",
    decisionCounts: "تمت الموافقة: {{approved}} · مرفوض: {{declined}} · بلا قرار: {{pending}}",
    senderWaiting: "بانتظار موافقة {{name}} على التقرير.",
    senderChangesNoReason: "طلب {{name}} تعديلات.",
    senderChanges: "طلب {{name}} تعديلات: «{{reason}}»",
    senderApprovedNoDate: "وافق {{name}} على هذا.",
    senderApproved: "وافق {{name}} على هذا في {{date}}.",
    nothingToDecide: "لا شيء هنا يحتاج إلى قرار. اقرأ التقرير، ثم اضغط موافقة أو إرجاع.",
    youApproved: "وافقت على هذا التقرير.",
    youApprovedOn: "وافقت على هذا التقرير في {{date}}.",
    titleDone: "تم إرسال المراجعة",
    title: "ملخص المراجعة",
  },
  threadEmptySender: "راسل {{name}} هنا. لا توجد رسائل بعد.",
  threadEmptyReviewer: "اطرح سؤالك على المفتش هنا. لا توجد رسائل بعد.",
  inspector: "المفتش",
  photoA11y: "الصورة {{number}} من {{total}} لـ {{item}}",
  allDecided: "تم البت في كل البنود. وقّع ثم اضغط موافقة.",
  decideAbove: "اختر من قراراتك في الأعلى.",
  urgentFlagged: "هذا البند مُعلَّم كعاجل.",
  urgentNow: "عاجل – يحتاج إلى معالجة الآن",
  recommendation: "التوصية",
  description: "الوصف",
  ratingType: {
    condition: "الحالة",
    level: "المستوى",
    passFlagFail: "ناجح أو مُعلَّم أو راسب",
    passFailNa: "ناجح أو راسب أو لا ينطبق",
    yesNo: "نعم أو لا",
  },
  theirDecisions: "قراراتهم",
  reviewerFallback: "المراجِع",
  theTeam: "الفريق",
  otherGroup: "أخرى",
  helloGreeting: "مرحبًا {{name}} — {{greeting}}",
  startedOn: "بدأ في {{date}}",
  completedOn: "اكتمل في {{date}}",
  inspectionFallback: "فحص",
  openAssetA11y: "فتح {{name}}",
  metaPill: "مراجعة التقرير",
  notYours: "يمكن فقط للشخص الذي أُرسل إليه هذا التقرير الموافقة عليه أو إرجاعه.",
  saveFailed: "تعذر حفظ اختيارك. تحقق من اتصالك وحاول مرة أخرى.",
  evidenceFailed: "تعذر تحميل النتائج والصور. تحقق من اتصالك وحاول مرة أخرى.",
  evidenceTimeout: "يستغرق تحميل الفحص وقتًا طويلاً. تحقق من اتصالك وحاول مرة أخرى.",
},
jobReportShare: {
  assetFallback: "الأصل",
  recipientFallback: "المستلم",
  jobFallback: "مهمة",
  emailSubject: "تقرير إنجاز المهمة – {{jobTitle}}",
headerTitle: "تقرير إتمام أمر العمل",
shareLinkNotFound: "لم يتم العثور على رابط المشاركة.",
goToAssetWrx: "انتقل إلى AssetWRX",
signInToViewTitle: "قم بتسجيل الدخول لمشاهدة هذا التقرير",
signInToViewBody: "تمت مشاركة تقرير إكمال أمر العمل هذا مع عنوان بريدك الإلكتروني. قم بتسجيل الدخول - أو قم بإنشاء حساب مجاني باستخدام هذا البريد الإلكتروني - وسيتم فتح التقرير تلقائيًا.",
signIn: "تسجيل الدخول",
createAccount: "إنشاء حساب",
noAccessOrNotFound: "لم يتم العثور على رابط المشاركة أو ليس لديك حق الوصول إليه. إذا تمت مشاركة التقرير باستخدام عنوان بريد إلكتروني مختلف، فقم بتسجيل الدخول باستخدام هذا العنوان لفتحه.",
tryAgain: "إعادة المحاولة",
loadingReport: "جارٍ تحميل التقرير…",
loadTimeout: "يستغرق تحميل التقرير وقتًا طويلاً. تحقق من اتصالك وحاول مرة أخرى.",
loadFailed: "تعذر تحميل هذا التقرير.",
},
qrScanFallback: {
linkToExistingAsset: "الربط بأصل موجود",
title: "لم يتم العثور على رمز QR",
message: "رمز QR الممسوح ضوئيًا \"{{value}}...\" لا يتطابق مع أي أصل موجود.",
createNewAsset: "إنشاء أصل جديد",
createNewAssetSubtitle: "قم بإنشاء أصل جديد وربط رمز QR به",
orLinkToExisting: "أو اربطه بأصل موجود",
chooseAssetPlaceholder: "اختيار أصل",
chooseAssetHint: "اختر الأصل لربط رمز QR هذا به",
linkQrCode: "ربط رمز QR",
successTitle: "نجاح",
successBody: "تم ربط رمز QR بالأصل بنجاح.",
errorTitle: "خطأ",
linkFailed: "فشل ربط رمز QR.",
},
inboxSidebar: {
  openA11y: "فتح {{title}}",
  openAction: "فتح",
  snoozeFailed: "تعذّر التأجيل. تحقّق من اتصالك وحاول مرة أخرى.",
  snoozedUntil: "تم التأجيل حتى {{time}}. سيعود حينها.",
groupLabel: {
high: "يحتاج إليك",
medium: "التحديثات",
low: "للعلم",
read: "مقروءة",
},
inboxA11y: "الإشعارات",
expandInbox: "إظهار الإشعارات",
myQueue: "الإشعارات",
collapseInbox: "إخفاء الإشعارات",
allCaughtUp: "اطّلعت على كل شيء",
noActionableNotifications: "ليس لديك إشعارات قابلة لاتخاذ إجراء بشأنها.",
itemsCountA11y_zero: "{{title}}، {{count}} عنصر",
itemsCountA11y_one: "{{title}}، عنصر واحد",
itemsCountA11y_two: "{{title}}، عنصران",
itemsCountA11y_few: "{{title}}، {{count}} عناصر",
itemsCountA11y_many: "{{title}}، {{count}} عنصرًا",
itemsCountA11y_other: "{{title}}، {{count}} عنصر",
snoozeA11y: "تأجيل {{title}}",
markDoneA11y: "تعليم {{title}} كمكتمل",
markAllRead: "قم بتمييز الكل كمقروء",
seeAllInMyQueue: "عرض كل الإشعارات",
seeAll: "شاهد الكل",
},
healthDetail: {
dismiss: "تجاهل",
assetHealth: "صحة الأصول",
close: "إغلاق",
subtitle: "الصحة التشغيلية هي درجة 0-100 من وثائق الامتثال وجداول الفحص والعمر وأوامر العمل المفتوحة والموافقات ونتائج الفحص. يتم قياس تصنيف حالة الفحص من 1 إلى 5 بشكل منفصل.",
notScored: "غير مُقيَّم",
whatChangedScore: "ما الذي غيّر درجتك",
scoreHint: "كل صف هو النقاط التي تمت إزالتها من 100 قبل أن يتم تحديد النتيجة بين 0 و100.",
emptyScoreLine: "لا يتم عرض أي نقاط لأنه لا توجد عمليات فحص مكتملة أو أوامر عمل مفتوحة أو عمليات فحص مجدولة أو مستندات امتثال أو طلبات مفتوحة لهذا الأصل.",
noPenaltiesLine: "لا توجد خصومات وفق القواعد الحالية — تبقى الدرجة عند الحد الأقصى.",
flaggedItemsTitle: "العناصر التي تم وضع علامة عليها في أحدث تقرير",
openFindingA11y: "النتيجة المفتوحة: {{label}}",
positiveAdjustments: "تعديلات إيجابية",
recommendedActions: "الإجراءات الموصى بها",
noActionsLine: "لا توجد إجراءات محددة — حافظ على تحديث عمليات الفحص وأوامر العمل.",
goTo: "اذهب إلى",
quickLinkJobs: "المهام",
quickLinkInspections: "التفتيش",
quickLinkStartInspection: "بدء فحص",
done: "تم",
},
contactInvite: {
invalidLink: "رابط الدعوة غير صالح",
invitationNotFound: "لم يتم العثور على الدعوة",
invitationExpired: "انتهت صلاحية هذه الدعوة",
invitationInvalid: "رابط الدعوة هذا لم يعد صالحًا.",
failedToLoad: "فشل تحميل الدعوة",
loadTimeout: "يستغرق تحميل الدعوة وقتًا طويلاً. تحقق من اتصالك وحاول مرة أخرى.",
emailMismatchTitle: "عدم تطابق البريد الإلكتروني",
emailMismatchBody: "تم إرسال هذه الدعوة إلى {{email}}. يرجى تسجيل الدخول باستخدام هذا البريد الإلكتروني للقبول.",
errorTitle: "خطأ",
loadingInvitation: "جارٍ تحميل الدعوة...",
invalidOrExpiredTitle: "غير صالحة أو منتهية الصلاحية",
tryAgain: "إعادة المحاولة",
goBack: "رجوع",
title: "دعوة جهة اتصال",
descBeforeName: "لقد تمت دعوتك للوصول إلى التطبيق باسم",
descAfterName: ". يؤدي هذا إلى ربط حسابك بجهة الاتصال؛ لن تتم إضافتك إلى الفريق.",
signInHint: "قم بتسجيل الدخول لقبول هذه الدعوة",
signIn: "تسجيل الدخول",
createAccount: "إنشاء حساب",
signInWithDifferentEmailHint: "تم إرسال هذه الدعوة إلى {{email}}. قم بتسجيل الدخول باستخدام هذا الحساب.",
signInWithDifferentAccount: "تسجيل الدخول بحساب مختلف",
accept: "قبول",
},
signatureField: {
defaultLabel: "توقيع",
defaultHelperText: "اضغط على المربع للتوقيع؛ تفتح اللوحة بملء الشاشة.",
clearSignature: "مسح التوقيع",
clear: "مسح",
signatureCapturedA11y: "تم التقاط التوقيع — اضغط للتغيير",
signed: "تم التوقيع",
tapToChange: "اضغط للتغيير",
openSignaturePadA11y: "افتح لوحة التوقيع للتوقيع",
tapToSignHere: "اضغط للتوقيع هنا",
signHereTitle: "وقّع هنا",
capturedSignatureA11y: "التوقيع الملتقط",
},
invoiceCapture: {
documentLabelPdf: "PDF",
documentLabelWord: "Word",
documentLabelGeneric: "مستند",
permissionRequiredTitle: "الإذن مطلوب",
grantCameraBody: "يُرجى منح حق الوصول إلى الكاميرا لالتقاط صورة.",
grantLibraryBody: "يرجى منح حق الوصول إلى مكتبة الصور.",
errorTitle: "خطأ",
couldNotOpenDocumentPicker: "تعذر فتح منتقي المستندات.",
uploadFailedTitle: "فشل الرفع",
failedToUploadFile: "فشل في تحميل الملف.",
actionSheetTakePhoto: "التقاط صورة",
actionSheetChoosePhoto: "اختر الصورة",
actionSheetChooseFile: "اختيار الملف (PDF، Word)",
addInvoiceTitle: "إضافة فاتورة",
addInvoiceBody: "اختر الصورة أو المستند",
removeFileTitle: "إزالة الملف",
removeFileBody: "هل أنت متأكد من أنك تريد إزالة هذا الملف؟",
remove: "إزالة",
removeInvoiceA11y: "قم بإزالة هذه الفاتورة",
addInvoiceOrReceiptA11y: "إضافة فاتورة أو إيصال",
},
complianceAuditDetail: {
dismiss: "تجاهل",
title: "الامتثال والتدقيق",
close: "إغلاق",
subtitle: "تعكس الدرجة المستندات وعمليات التفتيش والجداول الزمنية وأوامر العمل والموافقات المشتركة. إنها إرشادية وليست نصيحة قانونية.",
whatsAffectingScore: "ما الذي يؤثر على درجتك",
scoreHint: "يعرض كل عنصر النقاط المطبقة قبل تحديد النتيجة بين 0 و100.",
noScoredAdjustments: "لا توجد تعديلات مُحتسَبة — النتيجة عند خط الأساس (100 قبل التقييد).",
findingsInLatestReport: "النتائج في أحدث تقرير",
openFindingA11y: "النتيجة المفتوحة: {{label}}",
positiveSignals: "إشارات إيجابية",
recommendedActions: "الإجراءات الموصى بها",
noActionsLine: "لا توجد إجراءات محددة - استمر في مراقبة الجداول الزمنية والمستندات.",
automateTitle: "إنشاء أعمال التجديد تلقائيًا",
automateBody: "عندما تقترب شهادة أو مستند من انتهاء الصلاحية، ارفع أمر عمل التجديد وأخبر الشخص المناسب.",
goTo: "اذهب إلى",
quickLinkDocuments: "المستندات",
quickLinkInspections: "التفتيش",
quickLinkJobs: "المهام",
done: "تم",
},
videoCapture: {
permissionRequiredTitle: "الإذن مطلوب",
permissionMessage: "يرجى منح إذن الوصول إلى {{type}} للمتابعة.",
cameraAccessType: "الكاميرا",
photoLibraryAccessType: "مكتبة الصور",
videoTooLongTitle: "الفيديو طويل جدًا",
videoTooLongBody: "يجب أن تكون مدة مقاطع الفيديو {{max}} ثانية أو أقل. مدة هذا الفيديو {{actual}} ثانية.",
couldNotAddVideoTitle: "تعذر إضافة فيديو",
failedToAddVideo: "فشل في إضافة الفيديو. تحقق من اتصالك وحاول مرة أخرى.",
addVideoTitle: "إضافة فيديو",
chooseAnOption: "حدد خيارًا",
recordVideo: "تسجيل الفيديو",
chooseFromLibrary: "اختر من المكتبة",
videoLimitReachedTitle: "تم بلوغ الحد الأقصى لمقاطع الفيديو",
videoLimitReachedBody_one: "يمكنك إرفاق مقطع فيديو واحد هنا. أزل واحدًا لإضافة آخر.",
videoLimitReachedBody_other: "يمكنك إرفاق ما يصل إلى {{count}} مقطع فيديو هنا. أزل واحدًا لإضافة آخر.",
removeVideoTitle: "إزالة الفيديو",
removeVideoBody: "هل أنت متأكد من رغبتك في إزالة هذا الفيديو؟",
playVideoA11y: "تشغيل الفيديو {{index}}",
videoPreviewA11y: "معاينة الفيديو {{index}}",
videoLabel: "فيديو {{index}}",
removeVideoA11y: "إزالة الفيديو {{index}}",
addVideoLabel: "إضافة فيديو",
videoLimitReachedBody_zero: "لا يمكنك إرفاق أي مقطع فيديو هنا.",
videoLimitReachedBody_two: "يمكنك إرفاق مقطعي فيديو هنا. أزل واحدًا لإضافة آخر.",
videoLimitReachedBody_few: "يمكنك إرفاق ما يصل إلى {{count}} مقاطع فيديو هنا. أزل واحدًا لإضافة آخر.",
videoLimitReachedBody_many: "يمكنك إرفاق ما يصل إلى {{count}} مقطع فيديو هنا. أزل واحدًا لإضافة آخر.",
},
signatureCaptureModal: {
defaultHelperText: "وقّع بإصبعك أو بالماوس، ثم اضغط على \"تم\".",
cancelSigningA11y: "إلغاء التوقيع",
saveSignatureA11y: "حفظ التوقيع",
done: "تم",
},
conversationThread: {
defaultEmptyHint: "لا توجد رسائل حتى الآن. ابدأ المحادثة.",
updates: "التحديثات",
updatesWithName: "التحديثات مع {{name}}",
earlier: "في وقت سابق",
earlierA11y: "100 رسالة سابقة",
newer: "الأحدث",
newerA11y: "أحدث 100 رسالة",
latest: "آخر الرسائل",
latestA11y: "أحدث الرسائل",
loadingMessages: "جارٍ تحميل الرسائل…",
messagesUnavailable: "الرسائل غير متاحة الآن.",
noMessagesInThisPart: "لا توجد رسائل في هذا الجزء من المحادثة.",
startAnUpdatePlaceholder: "ابدأ تحديثًا…",
messageA11y: "رسالة",
sendMessageA11y: "أرسل رسالة",
couldNotSendMessage: "تعذر إرسال الرسالة.",
failedToSend: "فشل الإرسال",
},
guideArticle: {
userGuideTitle: "دليل المستخدم",
helpTitle: "المساعدة",
articleNotFound: "لم يتم العثور على المقالة",
whyItMatters: "لماذا هذا مهم",
showMe: "أرني",
howToDoIt: "كيفية القيام بذلك",
whatToDoNext: "ما يجب فعله بعد ذلك",
},
webQuickCreateMenu: {
quickCreateA11y: "إنشاء سريع",
quickCreate: "إنشاء سريع",
},
ownershipTransfer: {
aTeamMemberFallback: "عضو في الفريق",
couldNotUpdateTitle: "تعذر تحديث عملية النقل",
tryAgain: "حاول مرة أخرى.",
doneTitle: "تم",
offerLapsesSuffix: " ينتهي العرض في {{date}}.",
offeredOwnershipTitle: "عُرضت عليك ملكية {{teamName}}",
offeredOwnershipBody: "يريد {{initiatorName}} تسليم الفريق إليك. بصفتك المالك، تدير الأعضاء والفوترة وإعدادات مساحة العمل؛ ويصبح {{initiatorName2}} مسؤولًا.",
acceptOwnership: "قبول الملكية",
nowOwnTeam: "أنت الآن تملك {{teamName}}.",
decline: "رفض",
declinedOffer: "لقد رفضت العرض.",
waitingForAcceptTitle: "في انتظار قبول {{targetName}} للملكية",
waitingForAcceptBody: "لا شيء يتغير حتى يقبلوا. تبقى المالك في هذه الأثناء.",
cancelOffer: "إلغاء العرض",
offerWithdrawn: "تم سحب العرض.",
},
routeError: {
title: "واجهت هذه الشاشة مشكلة",
body: "لا يزال باقي التطبيق قيد التشغيل ويكون عملك دون اتصال بالإنترنت في قائمة الانتظار آمنًا. حاول مرة أخرى، أو ارجع وأعد فتح هذه الشاشة.",
referenceLabel: "المرجع: {{referenceId}}",
tryAgain: "إعادة المحاولة",
goBack: "رجوع",
},
photoAttachButton: {
couldNotAddPhotoTitle: "تعذر إضافة صورة",
pleaseTryAgain: "حاول مرة أخرى.",
permissionRequiredTitle: "الإذن مطلوب",
permissionMessage: "يرجى منح إذن الوصول إلى {{type}} للمتابعة.",
cameraAccessType: "الكاميرا",
photoLibraryAccessType: "مكتبة الصور",
addPhotoTitle: "إضافة صورة",
addPhotoBody: "أضف الصورة كما هي، أو ارسم لتسليط الضوء على المناطق أولاً.",
addNow: "أضف الآن",
photoAdded: "تمت إضافة الصورة",
drawToHighlight: "ارسم للتمييز",
addPhotoOptionsTitle: "إضافة صورة",
chooseAnOption: "حدد خيارًا",
camera: "الكاميرا",
photoLibrary: "مكتبة الصور",
attachPhotoA11y: "إرفاق صورة",
},
qrResolver: {
lookupTimedOut: "انتهت مهلة البحث عن رمز QR.",
resolvingQrCode: "جارٍ التعرّف على رمز QR...",
scannedAssetTitle: "لقد قمت بمسح أحد الأصول",
scannedAssetBody: "ينتمي هذا الرمز إلى أحد الأصول المُدارة في AssetWRX. اختر ما تريد القيام به.",
scannedAssetBodySignInOnly: "ينتمي هذا الرمز إلى أحد الأصول المُدارة في AssetWRX. سجّل الدخول لعرضه.",
reportAnIssue: "الإبلاغ عن مشكلة",
reportAnIssueA11y: "أبلغ عن مشكلة تتعلق بهذا الأصل - لا حاجة إلى حساب",
signInToView: "قم بتسجيل الدخول للمشاهدة",
signInToViewA11y: "قم بتسجيل الدخول لعرض هذا الأصل",
},
teamSwitcher: {
teamFallback: "فريق",
personal: "شخصي",
switchTeam: "تبديل الفريق",
cancel: "إلغاء",
},
requiredSkillsPicker: {
defaultLabel: "المهارات المطلوبة",
couldNotLoad: "تعذر تحميل المهارات الآن.",
couldNotRefresh: "تعذر تحديث المهارات. حاول ثانية.",
requiredTitle: "المهارات المطلوبة",
skillsTitle: "المهارات",
requiredHint: "حدد مهارة واحدة أو أكثر. مطلوب واحد على الأقل.",
optionalHint: "حدد مهارة واحدة أو أكثر من الكتالوج الخاص بك (اختياري).",
mustHaveTag: " · ضرورية",
removeSkillA11y: "إزالة {{name}}",
changeRequiredSkills: "تغيير المهارات المطلوبة",
selectAtLeastOne: "حدد مهارة واحدة مطلوبة على الأقل",
addSkillsOptional: "إضافة مهارات (اختياري)",
mandatoryHint: "ضع علامة «ضرورية» على مهارة، ولن يُقترح لهذا العمل أي شخص لا يملكها. أما المهارات الأخرى فترفع ترتيب من يملكها فقط.",
searchSkillsA11y: "البحث في المهارات",
searchSkillsPlaceholder: "البحث في المهارات...",
loadingSkills: "جارٍ تحميل المهارات...",
noSkillsFound: "لم يتم العثور على مهارات حتى الآن. أضف مهارات في إعدادات المقاول.",
noSkillsMatch: "لا توجد مهارات تطابق بحثك.",
removeSkillRowA11y: "إزالة {{name}}",
addSkillRowA11y: "أضف {{name}}",
mustHaveOnA11y: "{{name}} أمر لا بد منه. اجعله مفضلاً بدلاً من ذلك.",
mustHaveOffA11y: "اجعل {{name}} ضروريًا لهذا العمل",
mustHave: "ضرورية",
done: "تم",
},
reportingPage: {
executiveSummary: "الملخص التنفيذي",
supportingDetail: "التفاصيل الداعمة",
whatChanged: "ما الذي تغيّر",
whyItMatters: "لماذا هذا مهم",
action: "الإجراء",
hideReportStatements: "إخفاء بيانات التقرير",
showReportStatements: "إظهار بيانات التقرير والصفوف الداعمة",
sourceLabel: "سجلات هذا التقرير",
},
refineSheet: {
defaultTitle: "تصفية",
activeFilters_one: "{{count}} مرشح نشط",
activeFilters_other: "{{count}} مرشح نشط",
noActiveFilters: "لا توجد عوامل تصفية نشطة",
reset: "إعادة تعيين",
doneA11y: "تم",
done: "تم",
activeFilters_zero: "لا مرشحات نشطة",
activeFilters_two: "مرشحان نشطان",
activeFilters_few: "{{count}} مرشحات نشطة",
activeFilters_many: "{{count}} مرشحًا نشطًا",
},
qrCodeDisplay: {
noQrCode: "لا يتوفر رمز QR",
copyErrorTitle: "خطأ",
copyErrorBody: "فشل في نسخ رابط كود QR.",
shareMessageWithName: "رمز الأصل QR لـ {{name}}: {{url}}",
shareMessageNoName: "رمز الأصل QR: {{url}}",
copied: "تم النسخ",
copyLink: "انسخ الرابط",
share: "مشاركة",
},
jobCard: {
urgencyLow: "منخفض",
urgencyMedium: "متوسط",
urgencyHigh: "مرتفع",
urgencyCritical: "حرج",
scheduledFallback: "مُجدوَل",
dueDate: "يحل في {{date}}",
createdToday: "تم الإنشاء اليوم",
createdDate: "أُنشئ في {{date}}",
rejectedFallback: "مرفوضة",
rejectedWithReason: "مرفوض: {{reason}}",
unassigned: "غير مُكلَّف",
newUpdate: "تحديث جديد",
updatedAt: "حُدِّث {{when}}",
skillCount_one: "{{count}} مهارة",
skillCount_other: "{{count}} مهارة",
a11yJob: "أمر العمل: {{title}}",
a11yAsset: "الأصل: {{name}}",
a11yStatus: "الحالة: {{status}}",
a11yPriority: "الأولوية: {{priority}}",
a11yCategory: "الفئة: {{category}}",
a11yAssignee: "المكلَّف: {{name}}",
a11ySchedule: "الجدول: {{when}}",
a11yActivity: "النشاط: {{activity}}",
a11yAttentionOverdue: "تنبيه: لقد تأخر موعد التسليم",
a11yAttentionUnscheduled: "تنبيه: غير مجدول",
openAssetA11y: "فتح الأصل {{name}}",
detailsFallback: "التفاصيل",
noAsset: "بلا أصل",
followOnPending: "متابعة معلّقة",
overdue: "متأخر",
unscheduled: "غير مُجدوَل",
followOnPendingApproval: "متابعة · في انتظار الموافقة",
priorityColumnHint: "الأولوية",
assigneeColumnHint: "المكلَّف",
dueScheduleColumnHint: "المستحق/الجدول الزمني",
typeColumnHint: "النوع",
skillCount_zero: "لا مهارات",
skillCount_two: "مهارتان",
skillCount_few: "{{count}} مهارات",
skillCount_many: "{{count}} مهارة",
},
healthCard: {
assetHealth: "صحة الأصول",
noInspectionsYet: "لا توجد فحوصات حتى الآن",
viewOpenJobsInWork: "عرض أوامر العمل المفتوحة في العمل",
startInspectionInWork: "بدء الفحص في العمل",
viewHealthBreakdown: "عرض تفاصيل الصحة",
lastInspected: "آخر فحص {{date}}",
},
failedSyncRecovery: {
defaultTitle: "تعذرت المزامنة",
dismiss: "تجاهل",
copyError: "نسخ الخطأ",
retrySync: "إعادة محاولة المزامنة",
},
conflictResolution: {
title: "قام شخص آخر بتغيير هذا الفحص",
body: "حفظ شخص آخر هذا الفحص بينما كانت بعض إجاباتك تنتظر الحفظ. تبقى إجاباتك على هذا الجهاز حتى تختار.",
mergeAndSync: "الاحتفاظ بإجاباتي",
useLatestFromServer: "استخدام إجاباتهم",
hint: "يؤدي استخدام إجاباتهم إلى حذف إجاباتك غير المحفوظة من هذا الجهاز.",
decideLater: "القرار لاحقًا",
},
evidenceCapture: {
defaultDocumentSectionLabel: "المستندات",
media: "الوسائط",
addPhotoOrVideoA11y: "أضف صورة أو مقطع فيديو",
addPhotoA11y: "إضافة صورة",
addVideoA11y: "أضف فيديو",
noMediaAttached: "لا توجد وسائط مرفقة",
hintPhoto_one: "صورة واحدة كحد أقصى",
hintPhoto_other: "ما يصل إلى {{count}} صورة",
hintVideoWithPrefix_one: "حتى مقطع فيديو واحد",
hintVideoWithPrefix_other: "حتى {{count}} مقطع فيديو",
hintVideoNoPrefix_one: "{{count}} فيديو",
hintVideoNoPrefix_other: "{{count}} مقطع فيديو",
hintVideoDurationSuffix: "، بحد أقصى {{seconds}} ث",
addEvidence: "إضافة دليل",
takeAPhoto: "التقط صورة",
chooseAPhoto: "اختر صورة",
recordAVideo: "تسجيل فيديو",
chooseAVideo: "اختر مقطع فيديو",
hintPhoto_zero: "لا صور",
hintPhoto_two: "صورتان كحد أقصى",
hintPhoto_few: "ما يصل إلى {{count}} صور",
hintPhoto_many: "ما يصل إلى {{count}} صورة",
hintVideoWithPrefix_zero: "حتى {{count}} مقطع فيديو",
hintVideoWithPrefix_two: "حتى مقطعَي فيديو",
hintVideoWithPrefix_few: "حتى {{count}} مقاطع فيديو",
hintVideoWithPrefix_many: "حتى {{count}} مقطع فيديو",
hintVideoNoPrefix_zero: "لا مقاطع فيديو",
hintVideoNoPrefix_two: "مقطعا فيديو",
hintVideoNoPrefix_few: "{{count}} مقاطع فيديو",
hintVideoNoPrefix_many: "{{count}} مقطع فيديو",
},
localComplianceRead: {
clearRead: "مسح القراءة",
checkThis: "تحقق من هذا",
confirm: "تأكيد",
certificateNumber: "رقم الشهادة",
nextDue: "الاستحقاق التالي",
result: "النتيجة",
readingOnDevice: "جارٍ قراءة المستند على هذا الجهاز…",
useCertificateNumber: "استخدم رقم الشهادة {{value}}",
useNextDueDate: "استخدم تاريخ الاستحقاق التالي {{value}}",
title: "اقرأ من هذا المستند",
dismissA11y: "تجاهل قراءة المستند",
readOnDeviceNoCredits: "تمت القراءة على هذا الجهاز — دون استخدام أرصدة الذكاء الاصطناعي.",
use: "استخدام",
},
planPicker: {
trial: "تجربة مجانية لمدة {{days}} يومًا، ثم {{price}}",
adds: "يضيف {{list}}",
  titleLimit: "ترقية لإضافة المزيد",
  titleChange: "اختر خطتك",
  titleUnlock: "فتح {{feature}}",
  checkoutFailedTitle: "تعذّر بدء الدفع",
  introLimit: "اختر خطة لإضافة المزيد من الأصول وفتح المزيد من الميزات. أي فترة مجانية متبقية لديك تُنقل معك.",
  introChange: "تحدد خطتك الميزات المتاحة. تُفوتر الأصول وأرصدة الذكاء الاصطناعي بشكل منفصل.",
  loading: "جارٍ تحميل الخطط…",
  unavailable: "تعذر تحميل الخطط. حاول مرة أخرى لاحقًا.",
  notNow: "ليس الآن",
  current: "الحالية",
yourPlan: "خطتك",
payFor: "ادفع مقابل {{name}}",
renew: "جدِّد {{name}}",
  priceFree: "مجاني",
  priceTalkToUs: "تحدث معنا",
  priceFromPerAsset: "من {{price}}/أصل/شهر",
  priceFeePlusAssets: "{{price}}/شهر + لكل أصل",
  priceFeeOnly: "{{price}}/شهر",
  priceAnnualPlusAssets: "{{price}}/سنة + لكل أصل",
  priceAnnualOnly: "{{price}}/سنة",
  continueWith: "المتابعة مع {{name}}",
  contactSales: "التواصل مع المبيعات",
  managedOnWeb: "غير متاحة للشراء داخل التطبيق",
  otherPlans: "خطط أخرى",
  webOnly: "تُختار الخطط والأرصدة من الفوترة والاستخدام.",
},
storePlans: {
  title: "اشترك داخل التطبيق",
  loading: "جارٍ تحميل الخطط…",
  unavailable: "الاشتراكات غير متاحة الآن. حاول لاحقًا.",
  perMonth: "{{price}} شهريًا",
  perYear: "{{price}} سنويًا",
  subscribe: "اشترك",
  working: "جارٍ المعالجة…",
  restore: "استعادة المشتريات",
  activating: "جارٍ تفعيل خطتك…",
  pending: "تمت عملية الشراء. ستُحدَّث خطتك بعد لحظات. اضغط تحديث في الفوترة والاستخدام.",
  manage: "إدارة الاشتراك",
  billedElsewhere: "تتم فوترة اشتراك مساحة العمل هذه خارج هذا التطبيق.",
  termsIos: "يُحتسب الدفع على معرّف Apple عند التأكيد. يتجدد الاشتراك تلقائيًا ما لم يُلغَ قبل 24 ساعة على الأقل من نهاية الفترة الحالية. أدِره أو ألغِه من إعدادات حساب App Store.",
  termsAndroid: "يُحتسب الدفع على حساب Google عند التأكيد. يتجدد الاشتراك تلقائيًا ما لم يُلغَ قبل نهاية الفترة الحالية. أدِره أو ألغِه من اشتراكات Google Play.",
  termsOfUse: "شروط الاستخدام",
  privacyPolicy: "سياسة الخصوصية",
},
planLimit: {
subscriptionRequiredTitle: "تم بلوغ حد الخطة",
nextAssetNeedsPlan: "استخدمت الأصول المجانية في خطتك. الأصل التالي يحتاج إلى خطة مدفوعة.",
assetsUsed: "{{used}} من {{limit}} أصول في خطتك.",
checkoutUnavailableTitle: "الشراء غير متاح هنا بعد",
checkoutUnavailableBody: "لا يمكن شراء الخطط من هذا الإصدار. تواصل معنا وسنجهّزه لك.",
memberBodyCreate: "بلغت مساحة العمل حد الأصول في خطتها. يجب أن يختار مسؤول مساحة العمل خطة قبل إضافة أصل نشط آخر.",
memberBodyImport: "بلغت مساحة العمل حد الأصول في خطتها. يجب أن يختار مسؤول مساحة العمل خطة قبل استيراد المزيد من الأصول.",
  title: "تم بلوغ حد الخطة",
  notNow: "ليس الآن",
  seePlans: "عرض الخطط",
  perAsset: "لكل أصل",
  limit: "حد الأصول: {{count}}",
},
/** Field sync states (lib/fieldSync/contract.ts is the English contract; a test keeps en-US equal to it). */
fieldSync: {
local_draft: {
label: "محفوظ محليًا",
message: "محفوظ على هذا الجهاز — ستتم المزامنة تلقائيًا عند عودة الاتصال.",
},
pending_sync: {
label: "جارٍ المزامنة",
message: "جارٍ مزامنة تغييراتك…",
},
synced: {
label: "تمت المزامنة",
message: "تمت مزامنة جميع التغييرات.",
},
failed_sync: {
label: "يحتاج إلى انتباه",
message: "تعذّر حفظ هذا التغيير — عملك آمن على هذا الجهاز. انقر لإعادة المحاولة.",
messageWithDetail: "تعذّر الحفظ: {{detail}} انقر لإعادة المحاولة.",
},
conflict_review: {
label: "يحتاج إلى انتباه",
message: "قام شخص آخر بتحديث هذا — ألقِ نظرة سريعة قبل الحفظ.",
},
online_required: {
label: "يلزم الاتصال بالإنترنت",
message: "أعد الاتصال لإكمال هذا الإجراء. ستبقى المعلومات التي أدخلتها هنا.",
},
},
editionPlanSection: {
contactSalesTitle: "اتصل بالمبيعات",
contactSalesBody: "أرسل بريدًا إلكترونيًا إلى {{email}} لمناقشة خطة {{plan}}.",
notSet: "غير محدد",
customPricing: "تسعير مخصص",
noCharge: "بدون رسوم",
changePlan: "تغيير الخطة",
chooseAPlan: "اختر خطة",
changeTitle: "التبديل إلى {{name}}؟",
changeBody: "تبدأ الخطة الأكبر الآن، ويُحتسب فرق بقية فترة الفوترة هذه اليوم. تبدأ الخطة الأصغر، أو Free، في تاريخ التجديد؛ ولا يتغير شيء حتى ذلك الحين.",
scheduledTitle: "تم حجز تغيير الخطة",
scheduledBody: "تتغير خطتك إلى {{name}} في {{date}}. وحتى ذلك الحين تحتفظ بما لديك. اختر خطتك الحالية مرة أخرى لإلغاء التغيير.",
changeConfirm: "تبديل",
changeCancel: "ليس الآن",
billMonthly: "شهري",
billYearly: "سنوي",
billingTerm: "الفوترة",
},
legalDoc: {
unknownDocument: "مستند غير معروف.",
loadFailed: "تعذر تحميل هذا المستند. يرجى المحاولة مرة أخرى بعد قليل.",
versionLabel: "الإصدار {{version}}",
effectiveLabel: "ساري المفعول من {{date}}",
titleFallback: "قانوني",
loading: "جارٍ التحميل…",
errorTitle: "خطأ",
documentNotFound: "لم يتم العثور على المستند.",
},
notificationRecovery: {
title: "إشعار",
safeRecovery: "الاسترداد الآمن",
},
actionSheet: {
cancelA11y: "إلغاء",
cancel: "إلغاء",
},
actionPopover: {
closeCreateMenuA11y: "إغلاق قائمة الإنشاء",
},
fieldModeToggle: {
fieldModeA11y: "الوضع الميداني",
fieldModeHint: "يرفع التباين ومساحات اللمس للاستخدام في الأماكن المفتوحة",
fieldMode: "الوضع الميداني",
},
appErrorBoundary: {
title: "حدث خطأ ما",
body: "سجّل AssetWRX هذا الخطأ. يمكنك إعادة محاولة فتح هذه الشاشة دون فقدان العمل المحفوظ دون اتصال والمنتظر للمزامنة.",
retry: "إعادة المحاولة",
},
profileAvatar: {
profileAvatarA11y: "صورة الملف الشخصي",
profileInitialsA11y: "الأحرف الأولى من الملف الشخصي",
},
nativeDateTimePicker: {
selectDate: "اختر التاريخ",
selectTime: "حدد الوقت",
cancelSelectionA11y: "إلغاء تحديد {{mode}}",
cancel: "إلغاء",
confirmA11y: "تأكيد {{mode}}",
done: "تم",
},
assetMapView: {
basemapStreets: "الشوارع",
basemapSatellite: "القمر الصناعي",
basemapTopographic: "الطبوغرافية",
overlayClusters: "تجميع العناقيد",
overlayHeatmap: "خريطة الكثافة الحرارية",
overlaySelectionHighlight: "تمييز التحديد",
threeDCameraTilt: "إمالة الكاميرا ثلاثية الأبعاد",
threeDTerrainRelief: "تضاريس ثلاثية الأبعاد",
hideMapOptionsA11y: "إخفاء خيارات الخريطة",
basemapA11y: "الخريطة الأساسية: {{name}}",
mapOptionsA11y: "خيارات الخريطة",
rendererUnavailable: "عارض الخرائط غير متوفر على هذا الجهاز.",
},
uiCopy: {
  checkAnswerNotSavedTitle: "تعذّر حفظ هذه الإجابة",
  checkLoadFailed: "تعذّر تحميل هذا الفحص.",
  fieldAssist: {
    tryAgain: "يرجى المحاولة مرة أخرى.",
    revert: "استرجاع",
    discard: "تجاهل",
    accept: "قبول",
    suggestedTitle: "نص مقترح",
    dictate: "إملاء",
    stop: "إيقاف",
  },
markAllNotificationsAsRead_2777a0: "قم بوضع علامة على جميع الإشعارات كمقروءة",
retrySearch_eed38a: "أعد محاولة البحث",
importAssetsFromSpreadsheet_319028: "استيراد الأصول من جدول البيانات",
filterBySite_cf1cee: "تصفية حسب الموقع",
couldntLoadYourAssets_9878ab: "تعذر تحميل الأصول الخاصة بك",
yourAssetsAreStillThereCheckYour_f01439: "أصولك لا تزال موجودة. تحقق من اتصالك وحاول مرة أخرى.",
loadingRelationshipView_b7eaea: "جارٍ تحميل عرض العلاقة...",
noMappedAssetsYet_6f573a: "لا توجد أصول على الخريطة بعد.",
saveCoordinatesOnAnAssetToEnable_da096f: "احفظ إحداثيات على أصل لتمكين عرض الخريطة.",
mapUnavailableRightNow_d6091e: "الخريطة غير متاحة حاليًا.",
theAssetListStillWorksNormally_b8aeb7: "قائمة الأصول لا تزال تعمل بشكل طبيعي.",
loadingMap_8f267a: "جارٍ تحميل الخريطة...",
assignSite_e1d79b: "تعيين الموقع",
assignToSite_5f6e86: "تعيين للموقع",
contactInsight_51a9e3: "رؤية جهة الاتصال",
findContactsSkills_f8dc04: "ابحث في جهات الاتصال",
refineContactFilters_fa9072: "تصفية جهات الاتصال",
importContactsFromAFileOrYour_210d87: "استيراد جهات الاتصال من ملف أو جهازك",
refineContacts_982f6f: "تصفية جهات الاتصال",
opensFiltersToChangeWhichContactsAre_304ff8: "يفتح عوامل التصفية لتغيير جهات الاتصال التي يتم عرضها.",
chooseAContactToSeeSharedAssets_8202a6: "اختر جهة اتصال لرؤية الأصول المشتركة والطلبات والأعمال ذات الصلة دون مغادرة هذه الصفحة.",
noContactDetailsOnFile_131e9d: "لا توجد تفاصيل اتصال في الملف",
noLinkedSkills_16d322: "لا توجد مهارات مرتبطة",
noOpenJobsForThisContact_4857c4: "لا توجد أوامر عمل مفتوحة لجهة الاتصال هذه",
historyNotes_83ccc2: "السجل والملاحظات",
couldntRefreshYourWorkShowingWhatWas_8e2372: "تعذّر تحديث عملك — يُعرض آخر ما تم تحميله. انقر لإعادة المحاولة.",
generateAdvancedReport_7e5def: "إنشاء تقرير متقدم",
buildsAFullReportUsingInspectionsJobs_bfa133: "ينشئ تقريرًا كاملاً باستخدام عمليات الفحص وأوامر العمل والمستندات وبيانات المخاطر وتاريخ الصيانة والبحث الاختياري عبر الإنترنت.",
advancedReportInsight_a02085: "رؤية التقرير المتقدم",
noAdvancedReportGeneratedYet_59d1d4: "لم يتم إنشاء تقرير متقدم حتى الآن.",
fillInDetailsToSeeAPreview_84bd8b: "املأ التفاصيل لرؤية المعاينة هنا.",
assetNameRequired_06d7dc: "اسم الأصل (مطلوب)",
suggestedIdentity_36046f: "الهوية المقترحة",
dismissIdentitySuggestion_f3e055: "رفض اقتراح الهوية",
identifyTheAssetTypeFromThePhoto_d205fa: "حدد نوع الأصل من الصورة باستخدام الذكاء الاصطناعي",
identifiedFromPhoto_c90812: "تم التعرف عليه من الصورة",
applyTheIdentifiedAssetType_a066ab: "تطبيق نوع الأصل الذي تم التعرف عليه",
applyType_00972d: "تطبيق النوع",
dismissPhotoIdentity_a1052e: "إزالة هوية الصورة",
inServiceToday_7a4392: "في الخدمة اليوم؟",
yesInUse_0e9408: "نعم، قيد الاستخدام",
notYet_8de95f: "ليس بعد",
qRCodeWillBeLinkedAfterCreation_87a9e9: "سيتم ربط رمز QR بعد الإنشاء",
matchMyNearestSite_4d4d97: "مطابقة أقرب موقع إليّ",
tapToAddYourFirstPhoto_7f8b7c: "اضغط لإضافة صورتك الأولى",
gallery_9c30a3: "المعرض",
removeAllPhotos_6c3c73: "إزالة كل الصور",
iDSerialOptional_25584f: "المعرّف / الرقم التسلسلي (اختياري)",
thisReferenceLinksIoTDevicesAndAPI_4f5ce4: "يربط هذا المرجع أجهزة إنترنت الأشياء وأحداث API بهذا الأصل.",
scanIDOrSerial_956e65: "مسح المعرّف أو الرقم التسلسلي",
readFromPhoto_ee811f: "القراءة من الصورة",
relationshipsOptional_df493d: "العلاقات (اختياري)",
vehicleType_964438: "نوع المركبة",
fuelType_0e58d4: "نوع الوقود",
usage_0bb186: "الاستخدام",
propertyType_8ad7ea: "نوع العقار",
occupancy_570235: "الإشغال",
equipmentType_d92829: "نوع المعدات",
powerSource_56547a: "مصدر الطاقة",
installation_c81b79: "التركيب",
whereIsThisAssetInItsLife_ffff43: "أين يقع هذا الأصل في دورة حياته؟",
criticalityOptional_491f40: "الأهمية (اختياري)",
howCriticalIsThisAssetToOperations_04df20: "ما مدى أهمية هذا الأصل للعمليات؟",
operatingContextOptional_178f94: "سياق التشغيل (اختياري)",
complianceTagsOptional_2df1fc: "وسوم الامتثال (اختياري)",
identifyAndTag_f946d5: "تحديد ووضع علامة",
addMoreNowOrAnytimeLater_3eac61: "أضف المزيد الآن أو في أي وقت لاحق.",
potentialDuplicatesDetected_4b9918: "تم اكتشاف التكرارات المحتملة",
moreOptions_0a1b2c: "خيارات إضافية",
reviewMatchingAssetsBeforeCreatingANew_90559b: "قم بمراجعة الأصول المطابقة قبل إنشاء سجل جديد.",
useExistingAsset_3f06d4: "استخدام الأصل الموجود",
openExisting_941fb8: "فتح الأصل الموجود",
continueAnyway_011856: "استمر على أي حال",
createLinkPossibleDuplicate_e5dcab: "إنشاء + ربط بالمكرر المحتمل",
markIntentionallyDistinct_cc3540: "وضع علامة كمختلف عمدًا",
subtype_a729bb: "نوع المستند بالتحديد",
loadingAsset_a104a6: "جارٍ تحميل الأصل",
retryLoadingAsset_544af8: "أعد محاولة تحميل الأصل",
onlyTheAssetsOwnerOrItsTeam_95113f: "يمكن لمالك الأصل أو فريقه فقط تعديله. لا يزال بإمكانك عرضه وإنشاء عمل مرتبط به.",
basicDetails_42450f: "التفاصيل الأساسية",
photosOptional_c0ea6e: "الصور (اختياري)",
removeAllPhotos_1329e0: "إزالة كافة الصور",
egToyotaCamry2024_d36609: "مثال: تويوتا كامري 2024",
locationNotes_259645: "الموقع والملاحظات",
addDetailsAboutThisAsset_ec093a: "أضف تفاصيل حول هذا الأصل...",
identifiers_649d28: "المعرّفات",
importAssets_9158f1: "استيراد الأصول",
invalidSharedAssetLink_1f7b4c: "رابط الأصل المشترك غير صالح.",
sharedAsset_80c5e0: "أصل مشترك",
checkingAccess_c5108c: "جارٍ التحقق من الوصول...",
signInWithTheAccountThatWas_5dd47c: "قم بتسجيل الدخول باستخدام الحساب الذي تمت دعوته كجهة اتصال للمتابعة مباشرةً إلى هذا الأصل المشترك.",
signInToViewThisSharedAsset_c8d337: "قم بتسجيل الدخول لعرض هذا الأصل المشترك",
createAnAccountToViewThisShared_bef153: "قم بإنشاء حساب لعرض هذا الأصل المشترك",
couldNotCheckAccess_c29580: "تعذر التحقق من الوصول",
accessNotAvailable_7c84ab: "الوصول غير متاح",
thisShareIsntLinkedToYourAccount_305fbe: "لم يتم ربط هذه المشاركة بحسابك بعد، أو أن المالك أبطل الوصول. إذا قبلت للتو دعوة، قم بالتحديث للمحاولة مرة أخرى.",
backToAssets_caff2b: "العودة إلى الأصول",
refreshAccess_822875: "تحديث الوصول",
thisAssetIsNotSharedWithYour_76b685: "لم تتم مشاركة هذا الأصل مع جهة الاتصال المرتبطة بك، أو أن المشاركة أُنشئت لسجل جهة اتصال مختلف.",
shareDeclined_292608: "تم رفض المشاركة",
youPreviouslyDeclinedAccessToThisAsset_d9ccbb: "لقد رفضت سابقًا الوصول إلى هذا الأصل.",
acceptSharedAsset_79b229: "قبول الأصل المشترك",
declineSharedAsset_6908ef: "رفض الأصل المشترك",
sharedBy_a5fe3b: "تمت مشاركتها بواسطة",
youaposllBeAbleToView_bc03b3: "ستتمكن من المشاهدة",
acceptToViewThisAssetWithThe_8df15c: "اقبل لعرض هذا الأصل بالصلاحيات أعلاه، أو ارفض لإزالة الدعوة.",
assetdetail_27a5fa: "asset-detail",
templateName_0a8669: "اسم قائمة التحقق *",
templateNameRequired_5db301: "اسم قائمة التحقق (مطلوب)",
selectOneOrMore_1489f2: "حدد واحدًا أو أكثر",
updateChecklist_fce28f: "تحديث قائمة التحقق",
editChecklist_8c20d6: "تحرير قائمة التحقق",
inspectionObjective_6129b6: "هدف الفحص *",
describeWhatYouWantToInspectEg_1fb338: "صف ما تريد فحصه (على سبيل المثال فحص السيارة قبل الشراء والسلامة والحالة الميكانيكية).",
egPrepurchaseVehicleCheckSafetyAndMechanical_871268: "مثال: فحص السيارة قبل الشراء، السلامة والحالة الميكانيكية",
inspectionObjective_ce4266: "هدف الفحص",
categories_1c14ef: "الفئات *",
assetOptional_95db78: "الأصل (اختياري)",
selectAnAsset_9dd87a: "اختر أصلاً",
inspectionDepth_2b1225: "عمق الفحص",
targetDurationMinutesOptional_fe3727: "المدة المستهدفة (بالدقائق، اختيارية)",
targetDurationInMinutes_1897b3: "المدة المستهدفة بالدقائق",
evidenceMode_e83c42: "وضع الأدلة",
optimizeForSpeed_56e47b: "التحسين من أجل السرعة",
optimizationFocusOptional_0ebfbe: "محور التحسين (اختياري)",
failonlyEvidenceFocusKeepsEvidenceModeOn_1f0e17: "يبقي التركيز على أدلة الإخفاقات فقط وضع الأدلة على التقاط حالات الإخفاق فقط.",
baseTemplateOptional_d80914: "قائمة التحقق الأساسي (اختياري)",
preferToBuildItYourselfCreateManually_ae612e: "هل تفضل بنائه بنفسك؟ إنشاء يدويا",
draftSetup_a9804f: "إعداد المسودة",
guidance_b5e0b5: "إرشادات",
useThisWorkspaceToIterateObjectiveDuration_76a28d: "اذكر ما تفحصه ولماذا. يكتب الذكاء الاصطناعي مسودة القائمة؛ وتراجعها وتعدّلها قبل حفظ أي شيء.",
baseTemplate_54f2a3: "قائمة التحقق الأساسي",
generatingTemplateDraft_8fdb48: "جارٍ إنشاء مسودة قائمة التحقق...",
thisMayTakeAMoment_2cd85b: "قد يستغرق هذا بعض الوقت.",
buyUsageCredits_a49d2e: "شراء أرصدة الاستخدام",
templateName_954ab9: "اسم قائمة التحقق",
draftRationaleAndWarnings_0ce71c: "مبررات المسودة وتحذيراتها",
groupsItems_9bcc66: "المجموعات والعناصر",
draftSummary_4e141c: "ملخص المسودة",
warnings_1430f9: "تحذيرات",
reviewDraft_6a9bff: "مراجعة المسودة",
editThenSaveOrDiscard_f1ef70: "حرِّر ثم احفظ أو تجاهل",
inspectionreport_04aa89: "inspection-report",
createARecurringJob_4a519d: "إنشاء خطة صيانة",
newRecurringJob_dcc457: "خطة صيانة جديدة",
couldntLoadRecurringJobs_cbd362: "تعذّر تحميل خطط الصيانة",
noRecurringJobsYet_c5a4c5: "لا توجد خطط صيانة بعد",
openCurrentJob_cf8169: "فتح أمر العمل الحالي",
end_a2bb9d: "إنهاء",
jobreport_c30f90: "job-report",
pleaseWaitFinalisingYourSubscription_9839a5: "يرجى الانتظار — جارٍ إتمام اشتراكك.",
openPrivacyAmpData_453313: "افتح الخصوصية والبيانات",
retryLoadingYourWorkspace_be5137: "أعد محاولة تحميل مساحة العمل الخاصة بك",
signInToViewThisQuoteRequest_317846: "قم بتسجيل الدخول لعرض طلب عرض الأسعار هذا",
thisInviteWasSentToYourEmail_d77859: "تم إرسال هذه الدعوة إلى عنوان بريدك الإلكتروني. قم بتسجيل الدخول - أو قم بإنشاء حساب مجاني باستخدام هذا البريد الإلكتروني - وسيتم فتح طلب عرض الأسعار تلقائيًا.",
retryLoadingQuoteInvitation_7c3b72: "أعد محاولة تحميل دعوة عرض الأسعار",
ifTheInviteWasSentToA_2463c0: "إذا تم إرسال الدعوة إلى عنوان بريد إلكتروني مختلف، فقم بتسجيل الدخول باستخدام هذا العنوان لفتحها.",
retryLoadingQuoteContext_2406e9: "أعد محاولة تحميل سياق عرض السعر",
loadingQuoteDetailsAndSavedDraft_3c2a11: "جارٍ تحميل تفاصيل عرض الأسعار والمسودة المحفوظة",
requestDetails_bf5023: "تفاصيل الطلب",
additionalContextFromClient_1d46de: "سياق إضافي (من العميل)",
yourQuote_756213: "عرض الأسعار الخاص بك *",
yourQuoteRequired_afd50e: "عرض السعر الخاص بك (مطلوب)",
durationEstimateOptional_ace4e9: "تقدير المدة (اختياري)",
availabilityWindowOptional_9e64b7: "فترة التوفر (اختياري)",
materialsIncluded_5ffbdc: "المواد المتضمنة",
materialsDetails_72ea3e: "تفاصيل المواد",
details_4dade5: "التفاصيل...",
warrantyOptional_010797: "الضمان (اختياري)",
eg12Months_0ff628: "مثال: 12 شهرًا",
additionalDetails_04831c: "تفاصيل إضافية...",
attachmentsOptional_106896: "المرفقات (اختياري)",
loadingInspection_1ad221: "جارٍ تحميل الفحص...",
whatTheInspectionFound_b53913: "ما وجده التفتيش",
avgCondition_6b3737: "متوسط الحالة",
needsDecision_229276: "يحتاج إلى قرار",
inspectorNotes_2f7e20: "ملاحظات المفتش",
recommendedRepair_a70281: "الإصلاح الموصى به",
labourMaterials_08ee77: "العمالة والمواد",
estimatedCost_35caa4: "التكلفة المقدرة",
jobsFromThisReport_fa5fee: "أوامر العمل من هذا التقرير",
tapAJobToSeeFullDetails_fe7c8c: "اضغط على أمر العمل لرؤية التفاصيل والحالة الكاملة.",
couldNotSyncReview_375861: "تعذر مزامنة المراجعة",
inspectionreview_077ff2: "inspection-review",
acceptTeamInvitation_2f956c: "قبول دعوة الفريق",
acceptInvitation_f41d2a: "اقبل الدعوة",
declineTeamInvitationForNow_7ce799: "رفض دعوة الفريق في الوقت الحالي",
yourTeams_d63712: "فرقك",
createNewTeam_a8d9ef: "إنشاء فريق جديد",
addTeam_046c3a: "إضافة فريق",
noTeam_178b88: "لا يوجد فريق",
createATeamToCollaborateInviteContractors_bf3947: "قم بإنشاء فريق للتعاون ودعوة المقاولين وتعيين أوامر العمل.",
createTeam_8d826c: "إنشاء فريق",
createTeam_8b8973: "إنشاء فريق",
giveYourTeamAName_0161ea: "امنح فريقك اسمًا",
teamName_9b11ed: "اسم الفريق",
egAcmeInspections_60df82: "مثال: Acme للفحوصات",
newTeam_7ff544: "فريق جديد",
searchMembers_bdad23: "البحث عن الأعضاء...",
searchMembers_a1d97a: "البحث عن الأعضاء",
usedToMatchWorkToPeopleA_4d8242: "تُستخدم لمطابقة العمل مع الأشخاص. يمكن للمهمة أن تجعل مهارةً \"إلزامية\"، ولا يُقترح لها أي شخص لا يملكها.",
makeOwner_f99257: "تعيين كمالك",
resetTwofactor_4efb84: "إعادة تعيين التحقق بخطوتين",
removeMember_1c31d1: "إزالة العضو",
closeMenu_6c9fc9: "إغلاق القائمة",
invitations_4b0b9f: "الدعوات",
workspaceMembershipGrantsAppAccessContactRecords_e5c34b: "تمنح عضوية مساحة العمل إمكانية الوصول إلى التطبيق. تظل سجلات جهات الاتصال منفصلة ويمكن ربطها بالعمل دون أن تصبح أعضاء.",
inviteANewTeamMember_52559c: "قم بدعوة عضو جديد في الفريق",
invitePeople_e1eb97: "قم بدعوة الأشخاص",
emailAddressesForInvitationsOnePerLine_5e7e7e: "عناوين البريد الإلكتروني للدعوات، واحد في كل سطر",
addOneOrMoreAddressesSeparatedBy_162bd6: "أضف عنوانًا واحدًا أو أكثر، مفصولاً بسطر جديد أو فاصلة.",
whatShouldTheyBeAbleToDo_224294: "ما الذي يجب أن يكونوا قادرين على فعله؟",
cancelInviteForm_156d89: "إلغاء نموذج الدعوة",
noPendingInvitations_8d0735: "لا توجد دعوات معلقة",
showMeHowToInviteAMember_6b43bc: "أرني كيفية دعوة أحد الأعضاء",
showMeHowToInviteSomeone_61b6a4: "أرني كيفية دعوة شخص ما",
teamSettings_373140: "إعدادات الفريق",
workspaceDefaultsAccount_4ae7a6: "الإعدادات الافتراضية لمساحة العمل (الحساب)",
baselineDefaultsForTheWorkspaceYouCan_f78072: "خط الأساس الافتراضي لمساحة العمل. يمكنك أيضًا تعيينها في الحساب ← الإعدادات إذا لم تكن عضوًا في فريق.",
workspaceCommunication_2c579b: "تواصل مساحة العمل",
teamOverrides_4c6f5e: "تجاوزات الفريق",
overrideThisTeamOrKeepItInheriting_1d3b9a: "تجاوز إعدادات هذا الفريق، أو أبقِه وارثًا للإعدادات الافتراضية لمساحة العمل.",
teamCurrencyMode_f9eea7: "وضع عملة الفريق",
inheritWorkspace_879a54: "وراثة مساحة العمل",
override_842192: "تجاوز",
teamCommunicationMode_d0ba75: "وضع الاتصال بالفريق",
effectiveDefaultsInThisContext_3905f8: "الإعدادات الافتراضية السارية في هذا السياق",
onlyWorkspaceOwnersAndAdminsCanChange_325bf7: "يمكن فقط لمالكي ومسؤولي مساحة العمل تغيير هذه الإعدادات الافتراضية.",
openWorkspaceAIAndAutomationAudit_f2fd0f: "فتح سجل تدقيق الذكاء الاصطناعي والأتمتة في مساحة العمل",
workspaceAIAutomationAudit_79db57: "تدقيق الذكاء الاصطناعي والأتمتة في مساحة العمل",
renameTeam_bbd28e: "إعادة تسمية الفريق",
leaveTeam_b445f9: "اترك الفريق",
transferOwnership_a6819e: "نقل الملكية",
deleteTeam_a9661e: "حذف الفريق",
chooseAMemberToOfferOwnershipTo_ee74d9: "اختر عضوًا لعرض الملكية عليه. يجب أن يقبل؛ وحينها تصبح مسؤولاً.",
input_b568d4: "المدخلات",
plainlanguageGuideForThisTrigger_546a3a: "دليل باللغة البسيطة لهذا المشغل",
whatYouCanPassToAnotherSystem_3385b2: "ما يمكنك تمريره إلى نظام آخر",
sendingDataOutTypicalWebhookStep_9fa855: "إرسال البيانات (خطوة ربط الويب النموذجية)",
fixedPartReplaceTheExampleWebAddress_b73594: "الجزء الثابت - استبدل عنوان الويب النموذجي بعنوان الويب الخاص بك",
automaticPartFilledFromThisTriggerWhen_a65fba: "الجزء التلقائي - يتم ملؤه من هذا المشغل عند تشغيل الوصفة",
optionalFiltersAbove_b7c00b: "عوامل تصفية اختيارية (أعلاه)",
trigger_56cc41: "trigger.",
trigger_082e86: "trigger.…",
advancedRecipeBuilder_799724: "منشئ الوصفات المتقدم",
fullTriggerConditionAndStepControlFor_c176d8: "تحكم كامل في المشغل والشرط والخطوات للمستخدمين المتقدمين. يُفضَّل الوضع الموجَّه للأتمتة الجديدة عندما يناسبها قالب.",
triggerCatalog_b27d78: "كتالوج المشغلات",
actionCatalog_44816c: "كتالوج الإجراءات",
howToCreateARecipe_18bda4: "كيفية إنشاء وصفة",
recipesConnectATriggerWhenToOne_9c1ff3: "تربط الوصفات مشغلًا (متى) بإجراء واحد أو أكثر (ماذا). لا يعمل شيء في بيئة الإنتاج حتى تُفعِّل المسودة من القائمة على اليمين.",
recipeWizard_6830a5: "معالج الوصفة",
buildADraftBelowThenActivateIt_219398: "أنشئ مسودة أدناه، ثم فعِّلها من قائمة الوصفات.",
syncCompletedInspectionsToCRM_2594a7: "مزامنة الفحوصات المكتملة مع CRM",
optionalInternalNote_dedb5c: "ملاحظة داخلية اختيارية",
triggerType_a8b3dc: "نوع المشغل",
chooseWhenThisRecipeShouldRunOptions_065235: "اختر متى يجب تشغيل هذه الوصفة. يتم تجميع الخيارات حسب الموضوع؛ يعد الرمز القصير الموجود أسفل كل اسم مرجعًا اختياريًا إذا قمت بتعيين الحقول من نظام آخر.",
selectedTrigger_4573c4: "المشغل المحدد",
intervalMinutes_617c3f: "الفاصل الزمني بالدقائق",
conditionsOptional_d2f0fb: "(اختياري)",
onlyRunWhenTheIncomingEventMatches_c87bd3: "يعمل فقط عندما يتطابق الحدث الوارد مع كل صف تضيفه. استخدم أسماء حقول قصيرة من نظامك المصدر (مثل status أو id في السجل). اتركه فارغًا للتشغيل في كل مرة يُطلَق فيها هذا المشغل.",
jSONPath_a8136f: "مسار JSON",
dataobjectstatus_f2b5ba: "data.object.status",
value_8dce17: "القيمة",
completedOrOpenpaused_f935e5: "completed أو [\"open\",\"paused\"]",
addCondition_42fe69: "إضافة شرط",
noFiltersEveryMatchingTriggerRunsThe_5cdf5e: "لا توجد عوامل تصفية — كل مشغل مطابق يُشغِّل الإجراءات.",
actionsRunInOrder_dd55c2: "الإجراءات (تُشغَّل بالترتيب)",
pickWhatEachStepShouldDoThen_8b8ac5: "اختر ما يجب أن تفعله كل خطوة، ثم قم بلصق JSON أو تحريره. استخدم المربع الرمادي الموجود أسفل المشغل للحصول على أمثلة جاهزة للنسخ وأعد تسمية الحقول لتتناسب مع برامجك الأخرى.",
actionType_fece43: "نوع الإجراء",
fixedValuesJSON_3002d2: "قيم ثابتة (JSON)",
valuesFromTheEventJSON_11f1b5: "قيم من الحدث (JSON)",
urltriggerdatawebhookcallbackUrl_24747a: "{\"url\":\"trigger.data.webhook.callbackUrl\"}",
addAction_2824f0: "إضافة إجراء",
stableKeysScopesSchemasSamplesAndConnector_a9453b: "المفاتيح الثابتة والنطاقات والمخططات والعينات وتلميحات الموصلات للمنشئين الخارجيين.",
zapier_569964: "Zapier",
powerAutomate_81fa07: "Power Automate",
queuedSkippedSucceededAndFailedRecipeRuns_ceb06e: "عمليات تشغيل الوصفات المنتظرة والمتخطاة والناجحة والفاشلة، مع إعادة المحاولة يدويًا.",
noRunsHaveBeenRecordedYet_cfe5db: "لم يتم تسجيل أي عمليات تشغيل حتى الآن.",
importAssetsOrContactsFromACSV_8bb4c4: "قم باستيراد الأصول أو جهات الاتصال من ملف CSV أو Excel. قم بتعيين الأعمدة، ومعاينة التحقق من الصحة، ثم إنشاء السجلات.",
fileIntegrationHealth_2a85ee: "سلامة تكامل الملفات",
credentialsScopeRunsUnderYourSignedinWorkspace_7e301a: "بيانات الاعتماد / النطاق: يعمل بموجب أذونات مساحة العمل التي سجّلت الدخول بها؛ يتم ربط محتويات الملف قبل إنشاء السجلات.",
chooseACsvOrXlsxFileThe_d63529: "اختر ملف \u{2066}.csv\u{2069} أو \u{2066}.xlsx\u{2069}. يجب أن يحتوي الصف الأول على رؤوس الأعمدة.",
chooseFileToImport_7450d5: "اختر ملفًا لاستيراده",
whatAreYouImporting_15be02: "ما الذي تقوم باستيراده؟",
startOver_51dd91: "ابدأ من جديد",
mapColumnsAndOptionalDefaults_b4665a: "ربط الأعمدة والقيم الافتراضية الاختيارية",
flowFileObjectTypeAssetscontactsThisStep_1f9978: "المسار: الملف ← نوع الكائن (الأصول/جهات الاتصال) ← هذه الخطوة ← المعاينة (التحقق من الصحة) ← الاستيراد. هنا، اختر العمود في جدول البيانات الذي يملأ كل حقل في التطبيق. إذا كان هناك عمود مفقود أو كانت الخلايا فارغة، فعيّن قيمة افتراضية أدناه — فهي تملأ كل صف تنقصه هذه القيمة. الحقول التي تحمل علامة * تحتاج إلى عمود أو قيمة افتراضية. تعرض المعاينة المشكلات على مستوى الصف (مثل نوع فرعي غير صالح لنوع أصل هذا الصف) قبل حفظ أي شيء.",
browseAllowedSubtypeValuesByAssetType_a490ea: "تصفح قيم النوع الفرعي المسموح بها حسب نوع الأصل",
browseAllowedSubtypeValuesByAssetType_580a2c: "تصفح قيم الأنواع الفرعية المسموح بها (حسب نوع الأصل)",
sameFieldsAsWhenYouAddAn_66723f: "نفس الحقول التي تستخدمها عند إضافة أصل من علامة التبويب \"الأصول\" (إنشاء سريع).",
sameToplevelFieldsAsAssetDetailsSubtype_f2742b: "نفس حقول المستوى الأعلى مثل الأصل ← التفاصيل (النوع الفرعي، والأهمية، وقوائم العلامات). لم يتم استيراد مجموعة الخيارات المنظمة JSON هنا - استخدم النص العادي وقيم العلامات المسموح بها المدرجة في المرجع أعلاه.",
sameAsAddContactWhoThisRecord_ba62a1: "مثل إضافة جهة اتصال — من يمثله هذا السجل.",
whoCanSeeThisContactDefaultRoles_144799: "من يمكنه رؤية جهة الاتصال هذه؛ الأدوار الافتراضية إذا كان الملف لا يحتوي على أي منها.",
defaultIfEmpty_4d3688: "الافتراضي إذا كان فارغًا",
optionalUseForEveryRowWhenBlank_6bd308: "اختياري: يُستخدم لكل صف عندما يكون فارغًا",
oneDefaultSubtypeAppliesToEveryRow_1adca0: "يتم تطبيق نوع فرعي افتراضي واحد على كل صف يحتوي على خلية نوع فرعي فارغة. إذا كان ملفك يمزج بين أنواع الأصول، فيجب أن تكون هذه القيمة صالحة لجميعها — وعادةً ما تستخدم عمود النوع الفرعي بدلاً من ذلك.",
whenAMatchingRecordAlreadyExists_2bc530: "عند وجود سجل مطابق بالفعل",
updateMatchingRecords_acbd0a: "تحديث السجلات المطابقة",
matchAssetsByExternalIDAndContacts_440e6c: "قم بمطابقة الأصول حسب المعرف الخارجي وجهات الاتصال عبر البريد الإلكتروني.",
skipMatchingRecords_c0ae31: "تخطي السجلات المطابقة",
leaveExistingAssetWRXRecordsUnchanged_8f82ad: "اترك سجلات AssetWRX الموجودة دون تغيير.",
everyRowHasOneExplicitActionValidation_3af4e8: "يحتوي كل صف على إجراء واحد صريح. لن تتم كتابة أخطاء التحقق من الصحة.",
dataToImport_06e654: "البيانات المراد استيرادها",
valuesReadFromFileThisRowWill_bd4d2f: "القيم المقروءة من الملف (لن يتم استيراد هذا الصف)",
noNonemptyFieldsOnThisRow_33c6ae: "لا توجد حقول غير فارغة في هذا الصف.",
noMappedValuesForThisRow_b90088: "لا توجد قيم مربوطة لهذا الصف.",
importFinished_c3e89b: "اكتمل الاستيراد",
created_05e8fd: "تم الإنشاء: ",
andMore_c2145e: "...وأكثر",
importAnotherFile_6dc962: "قم باستيراد ملف آخر",
closeSubtypeReference_be22c0: "إغلاق مرجع النوع الفرعي",
subtypeValuesImport_0c957e: "قيم النوع الفرعي (استيراد)",
useTheCodeOrLabelInThe_0a2125: "استخدم الرمز أو التسمية في عمود النوع الفرعي. يجب أن تتطابق القيمة مع نوع الأصل الموجود في نفس الصف (أو النوع الافتراضي الخاص بك).",
connected_3dfd4d: "connected.*",
connectedruleexecuted_594141: "connected.rule.executed",
temperature_7033e9: "temperature",
xApiKey_cef935: "X-Api-Key",
httpspartnerexamplecomhooksassetwrx_79a38c: "https://partner.example.com/hooks/assetwrx",
jobId_f3d2e2: "jobId",
status_48a366: "status",
title_3c6de1: "title",
tESTASSET001_6a6a4b: "TEST-ASSET-001",
opsCopilot_5a267c: "مساعد العمليات",
httpsmcpexamplecom_a938f2: "https://mcp.example.com",
httpsexamplecomwebhooksassetwrx_fc61e9: "https://example.com/webhooks/assetwrx",
retryTestConnection_c9f32a: "أعد محاولة اختبار الاتصال",
refreshLogs_f970c3: "تحديث السجلات",
credentialAndScopeClarity_6593d1: "وضوح بيانات الاعتماد والنطاق",
assistantAccessStillRequiresWorkspaceEnablementPlus_df3128: "لا يزال وصول المساعد يتطلب تمكينه في مساحة العمل، بالإضافة إلى الموافقة على كل أداة/مورد في الكتالوج.",
retryConnectionTest_4382ef: "أعد محاولة اختبار الاتصال",
whatThisWizardSetsUp_ced2db: "ما يقوم بإعداده هذا المعالج",
thisExposesAssetWRXItselfAsAFirstparty_a9b397: "يعرِّض هذا AssetWRX نفسه كخادم MCP من الطرف الأول لمساحة العمل الحالية. يحصل عملاء MCP الخارجيون على قراءات ضمن نطاق مساحة العمل وأدوات كتابة قائمة على الاقتراح عبر الخلفية فقط.",
assetWRXSystemConnector_bbcfee: "موصل نظام AssetWRX",
thisAssistantConnectorIsAlwaysAvailableFor_6e5481: "موصل المساعد هذا متاح دائمًا لمساحة العمل، ومخفي عن المستخدمين العاديين، ولا يمكن إزالته.",
whatYouGet_8ac7aa: "ما تحصل عليه",
proposalfirstWritesAuditHistoryAndPerworkspaceEnablement_4086cb: "عمليات كتابة تبدأ بمقترح، وسجل تدقيق، وتمكين لكل مساحة عمل.",
readsExposedInV1_a02d0c: "القراءات المكشوفة في الإصدار 1",
workspaceSummaryDashboardStatusAssetsInspectionsJobs_ac16ca: "يقرأ ملخص مساحة العمل وحالة لوحة المعلومات والأصول وعمليات التفتيش وأوامر العمل وقوائم التحقق وسياق المساعد حيثما يكون ذلك آمنًا.",
builtinAssistantCapabilities_e47a5d: "قدرات المساعد المضمنة",
writeBehaviorInV1_73d808: "سلوك الكتابة في الإصدار 1",
materialToolsCreateProposalsFirstNothingCommits_9951b2: "تُنشئ الأدوات المؤثرة مقترحات أولاً. لا يُنفَّذ شيء حتى يوافق عليه مالك أو مسؤول هنا (ويتم إشعارهم)، ما لم يسمح المالك بتنفيذ ذلك الإجراء دون موافقة؛ ثم يستدعي العميل `confirm_proposed_action`.",
enableWorkspaceExposure_3b8aed: "تمكين إتاحة مساحة العمل",
turnOnTheEndpointConfirmTheWorkspace_c9acbe: "فعِّل نقطة النهاية، وتأكد من حالة مساحة العمل، وحدِّد المدة التي تبقى فيها مقترحات الكتابة صالحة قبل انتهائها.",
endpoint_92ec63: "نقطة النهاية",
proposalTTLMinutes_b08405: "مدة صلاحية المقترح (بالدقائق)",
validRange5To1440MinutesDefault_81859c: "النطاق الصالح: من 5 إلى 1440 دقيقة. الافتراضي: 30 دقيقة.",
approveToolsAndResources_6e4769: "الموافقة على الأدوات والموارد",
keepOnlyTheWorkspacesafeMCPSurfaceYou_433b1d: "احتفظ فقط بواجهة MCP الآمنة لمساحة العمل التي تريد أن يراها العملاء الخارجيون. تُخفى الصفوف المعطّلة من `tools/list` و`resources/list`.",
noFirstpartyMCPToolsAreRegisteredYet_a45543: "لم يتم تسجيل أدوات MCP للطرف الأول حتى الآن.",
noFirstpartyMCPResourcesAreRegisteredYet_58e317: "لم يتم تسجيل أي موارد MCP للطرف الأول حتى الآن.",
serviceaccountKeysAndScopes_8f39e0: "مفاتيح ونطاقات حساب الخدمة",
thisWizardDoesNotMintSecretsDirectly_ba8449: "لا يُنشئ هذا المعالج مفاتيح سرية مباشرةً. يجب على عملاء MCP الخارجيين استخدام مفاتيح API الحالية لحسابات خدمة مساحة العمل التي أُنشئت في «مفاتيح API والوصول».",
requiredScopeModel_206642: "نموذج النطاق المطلوب",
readsRequireMcpreadPlusTheRelevantDomain_efecc5: "تتطلب القراءات `mcp:read` بالإضافة إلى نطاق قراءة المجال ذي الصلة مثل `assets:read`.",
writeProposalsRequireMcpinvokePlusTheRelevant_bde894: "تتطلب مقترحات الكتابة `mcp:invoke` بالإضافة إلى نطاق الكتابة ذي الصلة مثل `jobs:write`.",
proposalConfirmationAndCancellationStayBoundTo_b8a213: "يظل تأكيد الاقتراح وإلغاؤه مرتبطَين بنفس مساحة العمل ومفتاح الطلب.",
clientSetupExample_dde719: "مثال على إعداد العميل",
safetyDefaults_f1e85c: "افتراضيات السلامة",
neverHandOutUnlessTheClientIs_26c700: "لا تقم أبدًا بتوزيع `*` ما لم يكن العميل موثوقًا به تمامًا. قم بتفضيل مفاتيح القراءة فقط أولاً، ثم المفاتيح المنفصلة القادرة على الاقتراح لعمليات التشغيل الآلي التي يتم التحكم فيها.",
reviewProposalsAndAuditHistory_945ebe: "مراجعة المقترحات وسجل التدقيق",
useThisStepToConfirmExternalClients_209a95: "استخدم هذه الخطوة للتأكد من أن العملاء الخارجيين يقرؤون الموارد المقصودة فقط، وأن الإجراءات المؤثرة تبقى قائمة على المقترحات أولًا وقابلة للتدقيق.",
proposalHistory_0f9af9: "سجل المقترحات",
noFirstpartyMCPProposalsYet_62c81f: "لا توجد مقترحات MCP من الطرف الأول حتى الآن.",
mcpProposalApprove: "موافقة",
mcpProposalDecline: "رفض",
mcpProposalDecideFailed: "تعذّر تسجيل القرار",
mcpAwaitingApprovalTitle: "بانتظار موافقتك ({{count}})",
mcpAwaitingApprovalHint: "طلب مساعد ذكاء اصطناعي إجراء هذه التغييرات. لا يحدث شيء حتى توافق؛ الطلبات المرفوضة أو المنتهية لا تُنفَّذ أبداً.",
mcpApproveAll: "الموافقة على الكل ({{count}})",
mcpDeclineAll: "رفض الكل ({{count}})",
mcpApproveAllConfirmTitle_zero: "الموافقة على {{count}} طلب؟",
mcpApproveAllConfirmTitle_one: "الموافقة على طلب واحد؟",
mcpApproveAllConfirmTitle_two: "الموافقة على طلبين؟",
mcpApproveAllConfirmTitle_few: "الموافقة على {{count}} طلبات؟",
mcpApproveAllConfirmTitle_many: "الموافقة على {{count}} طلبًا؟",
mcpApproveAllConfirmTitle_other: "الموافقة على {{count}} طلب؟",
mcpApproveAllConfirmBody: "ستتم الموافقة على كل طلبات \"{{action}}\" المنتظرة هنا، ويمكن للذكاء الاصطناعي بعدها تنفيذ كل منها.",
mcpDeclineAllConfirmTitle_zero: "رفض {{count}} طلب؟",
mcpDeclineAllConfirmTitle_one: "رفض طلب واحد؟",
mcpDeclineAllConfirmTitle_two: "رفض طلبين؟",
mcpDeclineAllConfirmTitle_few: "رفض {{count}} طلبات؟",
mcpDeclineAllConfirmTitle_many: "رفض {{count}} طلبًا؟",
mcpDeclineAllConfirmTitle_other: "رفض {{count}} طلب؟",
mcpDeclineAllConfirmBody: "لن يُنفَّذ أي من طلبات \"{{action}}\" المنتظرة هنا.",
mcpShowAll: "عرض الكل ({{count}})",
mcpShowFewer: "عرض أقل",
mcpApprovalRequired: "الموافقة مطلوبة",
mcpApprovalNotRequired: "يُنفَّذ دون موافقة",
mcpWaiveApprovalTitle: "السماح بتنفيذ \"{{name}}\" دون موافقة؟",
mcpWaiveApprovalBody: "يمكن لمساعد الذكاء الاصطناعي عندها إجراء هذا التغيير دون موافقة مالك أو مسؤول. يمكنك إعادة تفعيل الموافقة في أي وقت.",
mcpWaiveApprovalConfirm: "التنفيذ دون موافقة",
mcpApprovalUpdateFailed: "تعذّر تغيير الموافقة لهذا الإجراء.",
invocationAudit_06c951: "تدقيق الاستدعاءات",
noFirstpartyMCPInvocationHistoryYet_352e60: "لا يوجد سجل استدعاءات MCP من الطرف الأول حتى الآن.",
assetWRXMCPExposure_b699b4: "إتاحة AssetWRX عبر MCP",
exposeThisWorkspaceAsAFirstpartyMCP_7fae12: "أتِح مساحة العمل هذه كخادم MCP من الطرف الأول، مع قراءات ضمن نطاق مساحة العمل، وعمليات كتابة تبدأ بمقترح، وسجل تدقيق.",
firstpartySetup_16908a: "إعداد الطرف الأول",
loadingAssetWRXMCPExposure_4cc589: "جارٍ تحميل AssetWRX MCP...",
loadingAssetWRXMCPExposure_ec357e: "جارٍ تحميل إتاحة AssetWRX عبر MCP…",
workspaceControls_3cfefd: "ضوابط مساحة العمل",
useServiceaccountKeysWithMcpreadForResources_d8fd58: "استخدم مفاتيح حساب الخدمة مع `mcp:read` للموارد و`mcp:invoke` بالإضافة إلى نطاقات كتابة المجال للأدوات القادرة على الاقتراح.",
exposedTools_50a475: "الأدوات المكشوفة",
materialActionsStayProposalfirstEvenWhenEnabled_40b9b8: "تظل الإجراءات المؤثرة قائمة على المقترحات أولًا حتى عند تمكينها هنا.",
exposedResources_420463: "الموارد المكشوفة",
resourceTemplatesStayWorkspacescopedAndAreFiltered_664498: "تظل قوائم تحقق الموارد ضمن نطاق مساحة العمل ويتم تصفيتها حسب نطاقات حساب الخدمة.",
hideMoreActions_dd5915: "إخفاء المزيد من الإجراءات",
hideActions_affb29: "إخفاء الإجراءات",
showMoreActions_2ff0fa: "عرض المزيد من الإجراءات",
searching_ba2b5a: "جارٍ البحث...",
aICanDraftThisRepairJob_247024: "يمكن للذكاء الاصطناعي صياغة مهمة الإصلاح هذه",
why_d77989: "لماذا؟",
autoprepFollowupJobsAndScheduleTighteningSuggested_8be7b7: "مقترح: إعداد تلقائي، ومهام متابعة، وتضييق الجدول الزمني",
reviewAutomations_a7cc10: "مراجعة الأتمتة",
workingOnThisText_24726e: "جارٍ العمل على هذا النص...",
acceptIndividuallyOrInBulkEachWrites_bf195f: "اقبل كل عنصر على حدة أو دفعة واحدة — كلٌّ منها يكتب المسودة في العنصر المطابق أدناه.",
scheduledDate_b41cf0: "التاريخ المقرر",
selectADate_642b09: "حدد التاريخ",
chooseAssignee_3f1566: "اختر المكلف",
searchRequests_f13d82: "البحث في الطلبات",
noRequestsMatchYourSearch_a6c94d: "لا توجد طلبات تطابق بحثك.",
reportResponsePending_44c9b7: "الرد على التقرير معلق",
completionReviewPending_b4145c: "مراجعة الإكمال معلقة",
confirmDate_14424a: "تأكيد التاريخ",
confirmTheScheduledDate_b2fc2c: "قم بتأكيد التاريخ المقرر",
requestADifferentTime_0d7d3e: "اطلب وقتًا مختلفًا",
cancelRequest_84837a: "إلغاء الطلب",
cancelThisRequest_f56a63: "قم بإلغاء هذا الطلب",
preferredDate_921625: "التاريخ المفضل",
sendTheRescheduleRequest_b5dc9f: "أرسل طلب إعادة الجدولة",
cancelTheRescheduleRequest_9fb111: "إلغاء طلب إعادة الجدولة",
chooseNextAction_94f5b9: "اختر الإجراء التالي",
chooseAWorkPathTheRequestDetails_804dd3: "اختر مسار العمل؛ تظل تفاصيل الطلب مملوءة مسبقًا للتأكيد والتعيين والتوقيت.",
recommended_9ef937: "موصى به",
createWorkFromRequest_47ff21: "إنشاء عمل من الطلب",
confirmOwnerDueDatePriorityAndInstructions_8bc8fe: "قم بتأكيد المالك وتاريخ الاستحقاق والأولوية والتعليمات قبل إنشاء أمر العمل",
inspectRequest_5569d2: "فحص الطلب",
chooseStartNowAssignOrScheduleAfter_c334b8: "اختر البدء الآن أو التعيين أو الجدولة بعد تأكيد قائمة التحقق والنطاق",
whoApprovesWorkOnThisAsset_2e42d2: "من يوافق على العمل على هذا الأصل؟",
inspectionConditionTrend_179a6f: "اتجاه حالة التفتيش",
searchNameCompanyRole_baab25: "البحث عن الاسم والشركة والدور",
tryClearingTheSearchOrFilters_0818c7: "جرِّب مسح البحث أو عوامل التصفية.",
roleCompany_feef85: "الدور · الشركة",
changeAccess_fec7d5: "تغيير الوصول",
overdueWorkDocumentRiskAndOpenInspection_66d5d1: "العمل المتأخر ومخاطر المستندات وحالة الفحص المفتوح.",
noUrgentItemsRightNow_d3111a: "لا توجد عناصر عاجلة في الوقت الحالي.",
responsibleTeam_fd5898: "الفريق المسؤول",
approvesWork_3d9f4c: "يوافق على العمل",
signsOffInspectionsAndJobCompletionsAnd_35b573: "يعتمد الفحوصات وإكمال المهام، ويتحقق من صحة المستندات.",
draftInProgress_82d43c: "مسودة وقيد التنفيذ",
healthComplianceAndRiskAreScoredFrom_3c3736: "تُحتسب درجات الصحة والامتثال والمخاطر من السجل الكامل، وتُعرض لمالك الأصل وفريقه.",
noDocumentsMatchTheCurrentFilters_193238: "لا توجد مستندات تتطابق مع عوامل التصفية الحالية.",
noDocumentDatesThisMonth_01f2cb: "لا توجد تواريخ مستندات هذا الشهر.",
noDocumentsOnThisDay_ed643f: "لا توجد مستندات في هذا اليوم.",
plannedRunsWorkInFlightAndCompleted_12c7f2: "عمليات التشغيل المخططة والعمل الجاري والتقارير المكتملة لهذا الأصل.",
startAnInspectionToEstablishConditionAnd_5e3ce5: "ابدأ فحصًا لتحديد الحالة وأعمال المتابعة.",
completedCancelledInspections_118586: "عمليات التفتيش المكتملة والملغاة",
scheduledActiveAndClosedWorkTiedTo_bdec69: "العمل المجدول والنشط والمغلق المرتبط بهذا الأصل.",
noJobsForThisAsset_778118: "لا توجد أوامر عمل لهذا الأصل",
createFollowupWorkForThisAssetWhen_346e1d: "قم بإنشاء عمل متابعة لهذا الأصل عندما يحتاج شيء ما إلى اتخاذ إجراء.",
completedCancelledJobs_9dae91: "أوامر العمل المكتملة والملغاة",
searchKnowledge_42cfc4: "البحث في المعرفة",
addToKnowledge_52f38f: "أضف إلى المعرفة",
publicIntake_b9f61c: "البلاغات العامة",
turnThisOnToGetAQR_7dd031: "قم بتشغيل هذا للحصول على رمز QR ورابط يمكن لأي شخص استخدامه للإبلاغ عن مشكلة تتعلق بهذا الأصل - لا حاجة إلى حساب أو تسجيل دخول.",
publicIntakeQRCode_71844b: "رمز QR للبلاغات العامة",
howItWorks_1dd6a1: "كيف يعمل",
"1PrintOrDisplayThisQRCode_b4b58b": "1. قم بطباعة أو عرض رمز QR هذا على الأصل أو بالقرب منه.",
"2AnyoneScansItWithTheirPhone_399e27": "2. يقوم أي شخص بمسحه ضوئيًا باستخدام كاميرا هاتفه - بدون تطبيق أو تسجيل دخول.",
"3TheyDescribeTheIssueAndIt_0cf748": "3. يصفون المشكلة فتصل إلى طلباتك.",
printThisQRCode_355b08: "اطبع رمز QR هذا",
printQR_3d3e5d: "طباعة QR",
copyIntakeLink_d55587: "نسخ رابط البلاغات",
printOrShareTHISCodeItsThe_081cb8: "اطبع هذا الرمز أو شاركه — فهو الوحيد الذي يعمل دون حساب. ملصق QR الخاص بالأصل يفتح الأصل لأعضاء الفريق المسجّلين، ويطلب من أي شخص من خارج الفريق تسجيل الدخول.",
publicIntakeIsOnButThisApp_37c7e6: "البلاغات العامة مفعّلة، لكن إصدار التطبيق هذا لا يحتوي على عنوان ويب عام يوجّه إليه رمز QR، لذا لا يوجد رابط للمشاركة بعد. يُضبط هذا العنوان عند إنشاء الإصدار (EXPO_PUBLIC_WEB_APP_URL) — اطلب من الشخص الذي أنتج هذا الإصدار ضبطه. تطبيق الويب غير متأثر.",
closePublicIntake_83ee14: "إغلاق البلاغات العامة",
clearFilter_b667d6: "مسح الفلتر",
retire_c9714c: "الإخراج من الخدمة نهائيًا",
cancelRetiring_021841: "إلغاء الإخراج من الخدمة",
thisAssetIsStillInServiceTake_6d33c8: "هذا الأصل لا يزال في الخدمة. أخرجه من الخدمة أولًا، ثم أغلق سجله نهائيًا.",
decommissionThisAssetFirst_3dba4e: "أخرج هذا الأصل من الخدمة أولاً",
decommissionFirst_449932: "إخراج من الخدمة أولاً",
whyIsItBeingRetired_424b30: "لماذا يُخرج هذا الأصل من الخدمة نهائيًا؟",
anythingTheRecordShouldSayEgReplaced_39f4f8: "أي شيء يجب أن يذكره السجل — مثلًا: استُبدل بالوحدة B-12.",
retirementNote_69e12e: "ملاحظة الإخراج من الخدمة",
disposalOptional_664c05: "التخلص (اختياري)",
recipientBuyerScrapYardLessor_bc1312: "المستلم — المشتري، ساحة الخردة، المؤجر",
disposalRecipient_0bcdb7: "مستلم التخلص",
disposalValue_7e69e8: "قيمة التخلص",
whatHappens_d208fd: "ماذا يحدث",
retireThisAsset_843886: "إخراج هذا الأصل من الخدمة نهائيًا",
editSharedAccess_874a55: "تحرير الوصول المشترك",
canRequestWorkLetsThemSubmitInspection_66303c: "\"يمكن طلب العمل\" يتيح لهم إرسال طلبات التفتيش أو أمر العمل؛ \"يمكن العرض\" للقراءة فقط. يمكن لكل منهما رؤية أوامر العمل وعمليات التفتيش.",
documentsArePrivateByDefaultTurnThis_f79dc7: "تكون المستندات خاصة بشكل افتراضي. قم بتشغيل هذا للسماح لهم بتنزيل ملفات الأصول.",
canDownloadDocuments_d483c0: "يمكنه تنزيل المستندات",
thisContactIsNotLinkedToAn_cfbe9b: "لم يتم ربط جهة الاتصال هذه بمستخدم في التطبيق بعد. سيؤدي الحفظ إلى مشاركة الأصل، لكن يجب عليهم قبول دعوة جهة اتصال قبل أن يتمكنوا من رؤيته في التطبيق.",
relationshipToThisAsset_cc572f: "العلاقة بهذا الأصل",
moreRelationships_1c2d3e: "علاقات أخرى",
howThisContactIsLinkedOnThe_b75d5d: "كيفية ربط جهة الاتصال هذه في سجل الأصول (المؤسسة/الإيجار). حدد علاقة واحدة أو أكثر.",
whatThisContactCanDoInThe_1f7b90: "ما يمكن أن تفعله جهة الاتصال هذه في مساحة عمل الأصول المشتركة. تتيح لهم ميزة \"يمكن طلب العمل\" إرسال طلبات الفحص أو أمر العمل؛ \"يمكن العرض\" للقراءة فقط. يمكن لكل منهما رؤية أوامر العمل وعمليات التفتيش.",
saveShare_bcf6ed: "حفظ المشاركة",
qR_45e7a1: "QR",
scanOrPrintLabelsForThisAsset_c3fdde: "امسح ضوئيًا أو اطبع ملصقات لهذا الأصل.",
print_5b221e: "طباعة",
qRCodeWillBeGeneratedWhenAsset_31ea4e: "سيتم إنشاء رمز QR عند حفظ الأصل",
assetIntelligence_d0cf4b: "ذكاء الأصول",
conditionNotRatedYet: "لم تُقيَّم الحالة بعد · يحتاج إلى فحص",
why_21e2ca: "لماذا",
keepTheCurrentSchedule_ade385: "حافظ على الجدول الزمني الحالي",
keepCurrentSchedule_24ceb0: "حافظ على الجدول الزمني الحالي",
operationalReadiness_f83f30: "الاستعداد التشغيلي",
noReadinessChecksCurrentlyNeedAttention_8a0ffe: "لا توجد عمليات فحص جاهزية تحتاج إلى الاهتمام حاليًا",
foundations_2efa1e: "الأسس",
topCommandsForThisAsset_43db45: "أهم الأوامر لهذا الأصل",
seeAll_9ff264: "شاهد الكل ←",
noCompletedOrApprovedInspectionCyclesAre_58ad5b: "لم يتم تسجيل أي دورات فحص مكتملة أو معتمدة.",
noLinkedAssetsYet_f0421d: "لا توجد أصول مرتبطة حتى الآن.",
viewRelationships_855c37: "عرض العلاقات ←",
noOpenJobsOrInprogressInspectionsAre_c07385: "لم يتم تسجيل أي أوامر عمل مفتوحة أو عمليات تفتيش قيد التنفيذ.",
sharedContactsAndQRScannersReportIssues_ece9d2: "تُبلغ جهات الاتصال المشتركة ومن يمسحون رمز QR عن المشكلات مباشرةً في قائمة عملك.",
addArticle_2f4275: "إضافة مقالة",
shareLibrary_4057e3: "مشاركة المكتبة",
signInToSeeThisKnowledge_4eaa03: "قم بتسجيل الدخول لرؤية هذه المعرفة",
yourSessionHasExpiredSoTheseArticles_f87fa2: "لقد انتهت صلاحية جلسة العمل الخاصة بك، لذا لا يمكن تحميل هذه المقالات. قم بتسجيل الدخول مرة أخرى للمتابعة.",
couldnrsquotLoadKnowledge_da1c79: "تعذر تحميل المعرفة",
tryLoadingKnowledgeAgain_1b6aa1: "حاول تحميل المعرفة مرة أخرى",
refineArticles_d1b417: "تصفية المقالات",
kind_e00ac2: "النوع",
egElectrical_0b7339: "مثال: كهربائي",
egBoilerAnnual_18e665: "مثال: غلاية، سنوي",
pinnedOnly_bd8de5: "المثبت فقط",
egBoilerResetProcedure_91545f: "مثال: إجراء إعادة ضبط الغلاية",
uRL_0e2d9b: "URL",
https_1a6627: "https://…",
content_4f9be0: "المحتوى",
writeStepsAnswerOrNotes_974f8b: "كتابة الخطوات أو الإجابة أو الملاحظات...",
chooseFile_3fd558: "اختر ملف...",
setTitlecategoryAboveBeforeUploadingOptional_cea97d: "قم بتعيين العنوان/الفئة أعلاه قبل التحميل (اختياري).",
shortSummaryOrContext_239731: "ملخص قصير أو سياق",
pinned_f93121: "مثبّت",
shareKnowledge_a28e38: "شارك المعرفة",
shareWith_134bfa: "شارك مع",
chooseContactToShareWith_f8c887: "اختر جهة اتصال للمشاركة معها",
noEmailOnContact_2730d7: "لا يوجد بريد إلكتروني لجهة الاتصال",
chooseContact_4a3f8f: "اختر جهة اتصال...",
createLinkCopy_460e24: "إنشاء رابط ونسخه",
activeShares_8d41b3: "المشاركات النشطة",
revokeShare_1d9e95: "إلغاء المشاركة",
addAtLeastTwoAssetsInThis_92640d: "أضف أصلين على الأقل في هذا النطاق لإنشاء روابط بينهما.",
startInWork_47c346: "ابدأ في «العمل»",
propertyCategory_dfd0bc: "فئة العقار",
propertySubtype_7092d7: "النوع الفرعي للعقار",
vehicleClass_1807bf: "فئة المركبة",
equipmentClass_f1c8f7: "فئة المعدات",
domain_9b1091: "المجال",
furnished_8ab38e: "مفروشة",
operatingContext_c28bb5: "سياق التشغيل",
usageType_0193f0: "نوع الاستخدام",
mounting_26ae06: "طريقة التثبيت",
safetyClass_c2825e: "فئة السلامة",
environment_d443a1: "البيئة",
riskTags_391936: "علامات المخاطر",
otherAssetCategory_c3e627: "فئة الأصول الأخرى",
propertySystems_2983a3: "أنظمة العقار",
conditionFlags_0fd793: "علامات الحالة",
transmission_ace17e: "ناقل الحركة",
lastServiceDate_6a44ff: "تاريخ آخر خدمة",
roadworthinessExpiry_a32510: "انتهاء صلاحية فحص السلامة المرورية",
insuranceExpiry_5788c0: "انتهاء التأمين",
capacityUnit_f595ba: "وحدة السعة",
useStructuredOptionSetsSoTemplateRecommendation_a4913e: "استخدم مجموعات الخيارات المنظمة حتى تظل توصية قائمة التحقق وإنشاءه نظيفين.",
addOneOrMoreRelationshipsNowOr_bdce2c: "قم بإضافة علاقة واحدة أو أكثر الآن، أو اتركه فارغًا لإبقاء هذا الأصل مستقلاً.",
noDraftRelationshipsAddedYet_0698d2: "لم تتم إضافة مسودة العلاقات حتى الآن.",
chooseTheRelatedAsset_35789f: "اختر الأصل ذي الصلة",
fromThisAsset_48c52c: "من هذا الأصل",
toThisAsset_f70126: "إلى هذا الأصل",
relationshipCriticality_1a33c6: "أهمية العلاقة",
riskPropagationMode_720d7e: "وضع انتشار المخاطر",
propagationMode_fa66d1: "وضع الانتشار",
noAssetsToVisualizeYet_c42bdd: "لا توجد أصول لعرضها بصريًا حتى الآن.",
links_014bcd: "الروابط",
display_574ff9: "العرض",
viewAffectedWork_acb250: "عرض العمل المتأثر ←",
relationshipTypes_558b4b: "أنواع العلاقات",
clickToEditOrRemove_8526e9: "انقر للتعديل أو الإزالة",
understandingRisk_2e43d7: "فهم المخاطر",
whatRaisesOrLowersLikelihood_622b19: "ما يزيد أو يقلل من الاحتمالية",
whatRaisesOrLowersImpact_767cc7: "ما يرفع التأثير أو يخفضه",
noRelationshipbasedAdjustmentsToShow_47ffe9: "لا توجد تعديلات على أساس العلاقة لإظهارها.",
likelihoodMixScoreWeightContribution_2582ca: "مزيج الاحتمالية (النتيجة × الوزن = المساهمة)",
impactMix_ec0686: "مزيج التأثير",
rawWeightedValues_f4522d: "القيم المرجحة الأولية",
assetRisk_54b50c: "مخاطر الأصل",
"55Matrix_f6b01d": "مصفوفة 5×5",
topDrivers_f8f235: "أبرز العوامل المؤثرة",
whyThisRiskScore_6c74da: "لماذا درجة المخاطرة هذه؟",
mo_e9e0ce: "/شهر",
aW_073d87: "AW",
suggestedNextStep_4a96db: "الخطوة التالية المقترحة: ",
complianceAndAudit_d16087: "الامتثال والتدقيق",
moreInBreakdown_3e1121: "+ المزيد بالتفصيل",
opensMapsWithDirectionsFromYourLocation_44a789: "يفتح الخرائط مع الاتجاهات من موقعك",
closeDocument_7866c7: "إغلاق المستند",
openingFile_c515cb: "جارٍ فتح الملف",
notDisplayingOpenItInYourBrowser_a5761f: "لا يظهر؟ افتحه في متصفحك.",
openInBrowser_052269: "فتح في المتصفح",
noInappPreview_37df05: "لا توجد معاينة داخل التطبيق",
previewUnavailable_36d31d: "المعاينة غير متاحة",
thisDocumentCouldNotBeDisplayedHere_e78b36: "لا يمكن عرض هذا المستند هنا. استخدم \"فتح في المتصفح\" أدناه لقراءته.",
theDocumentRendererIsUnavailableInThis_3dc0a5: "عارض المستندات غير متوفر في هذا الإصدار. استخدم \"فتح في المتصفح\" أدناه.",
loadingDocument_77cac7: "جارٍ تحميل المستند",
couldNotReadThisFile_fce43e: "تعذر قراءة هذا الملف",
theFileCouldNotBeDownloadedUse_fd63bb: "تعذر تنزيل الملف. استخدم \"فتح في المتصفح\" أدناه، أو حاول مرة أخرى عندما يكون لديك اتصال مستقر.",
loadingVideo_c18920: "جارٍ تحميل الفيديو",
workArrivesFromTheFieldAQR_d69f49: "يصل العمل من الميدان، أو من مسح رمز QR، أو من مقدّم طلب — ثم يمر بمراحله حتى المراجعة.",
howAssetWRXWorks_a6652b: "كيف يعمل AssetWRX",
theEverydayLoopEndToEndTap_f41cec: "الدورة اليومية من البداية إلى النهاية. اضغط على أي مرحلة للانتقال إليها.",
howToGetTheMostOutOf_6ecde4: "كيفية تحقيق أقصى استفادة من AssetWRX - حسب المهمة، من خلال الإرشادات التفاعلية.",
loadingInspectionDetails_07441a: "جارٍ تحميل تفاصيل الفحص...",
weCouldntLoadThisInspection_0d9c6e: "لم نتمكن من تحميل هذا الفحص",
loadingChecklist_6d4b18: "جارٍ تحميل قائمة التحقق…",
inspectionDetails_f70991: "تفاصيل الفحص",
thisInspectionWasCreatedFromARequest_62e54f: "تم إنشاء هذا الفحص من طلب ويظل مرتبطًا بالجدول الزمني للطلب الخاص به.",
openSourceRequest_847fb2: "فتح الطلب الأصلي",
clearSkip_6abff6: "مسح التخطي",
clearsSkipSoYouCanAnswerThis_fdd91c: "يقوم بمسح التخطي حتى تتمكن من الإجابة على هذا العنصر.",
useYesNoPassFailStarsOrSkipBelow_c5d2c7: "استخدم نعم/لا، أو نجاح/فشل، أو النجوم، أو التخطي أسفل العنوان للإجابة.",
unskipItem_a158ab: "إلغاء تخطي العنصر",
unskip_cde472: "إلغاء التخطي",
skipItem_cb392b: "تخطي العنصر",
opensAShortFormYouCanSkip_8bc9f3: "يفتح نموذجًا قصيرًا. يمكنك تخطي مع أو بدون ملاحظة.",
notConfirmed_b9e09a: "غير مؤكد",
evidenceRecommendedAddAPhotoOfThe_f5d5bd: "الأدلة الموصى بها - أضف صورة للمشكلة.",
noVideosRecorded_803350: "لم يتم تسجيل أي مقاطع فيديو",
upTo3Photos1VideoMax_382f91: "حتى 3 صور · فيديو واحد، بحد أقصى 20 ثانية",
inspectionAttachments_4eccaa: "مرفقات الفحص",
skipTheCurrentGroupOfItemsBecause_22712a: "تخطَّ مجموعة العناصر الحالية لأن أيًّا منها لا ينطبق",
skipThisGroup_348a6d: "تخطي هذه المجموعة",
keyboardShortcuts_266695: "اختصارات لوحة المفاتيح",
closeKeyboardShortcuts_b87b09: "إغلاق اختصارات لوحة المفاتيح",
requestConversation_7db6bd: "محادثة الطلب",
retryExport_f58f53: "إعادة محاولة التصدير",
completedTheWork_099993: "أكمل العمل",
notSharedYetUseShareAboveTo_81bebb: "لم تتم مشاركته بعد — استخدم المشاركة أعلاه لإرسال هذا التقرير إلى جهة اتصال.",
couldNotGenerateReport_fb1286: "تعذر إنشاء التقرير",
showAllDetails_c5a7a8: "إظهار كافة التفاصيل",
neededBeforeCompletion_304a39: "مطلوب قبل الإكمال",
completionProgress_e2e2b3: "تقدم الإكمال",
latestUpdate_749cd8: "آخر تحديث",
noUpdatesYet_24f53d: "لا توجد تحديثات حتى الآن.",
beforeYouSubmit_ede7c3: "قبل الإرسال:",
invoiceExtraction_b8d23c: "استخراج الفاتورة",
reviewExtractedItems_9649fe: "مراجعة العناصر المستخرجة",
noLineItemsDetectedTryAClearer_7ebd61: "لم يتم اكتشاف أي عناصر. جرّب التقاط صورة أكثر وضوحًا أو أضف عناصر يدويًا.",
removeLineItem_68fb55: "إزالة البند",
useCalculated_7192f0: "استخدام القيمة المحسوبة",
leaveBlankToRecordAs0Enter_74cafa: "اتركه فارغًا للتسجيل كـ 0. أدخل المبلغ الكامل لأمر العمل هذا.",
addLineItem_2932d8: "إضافة بند",
invoiceOrReceipt_bcd947: "فاتورة أو إيصال",
attached_8e632c: "مرفق",
pDFImageOrWordDocument_812ab0: "PDF أو صورة أو مستند Word.",
whyThisJobWasSuggested_e32a41: "لماذا تم اقتراح أمر العمل هذا",
what3words_881ff5: "what3words",
filledcountsoap_1a66d3: "///filled.count.soap",
nothingToChooseFromYet_978c4e: "لا يوجد ما يمكن الاختيار منه بعد.",
reportNotAvailable_c048c4: "التقرير غير متاح",
thisLinkMayBeInvalidOrThe_0e72cd: "قد يكون هذا الرابط غير صالح أو لم تعد تتم مشاركة التقرير.",
itemsChecked_34daa1: "العناصر المفحوصة",
needAttention_46d04d: "بحاجة إلى الاهتمام",
seeTheFullReport_d02b8d: "شاهد التقرير الكامل",
signInToRequestAccess_2e7a0e: "قم بتسجيل الدخول لطلب الوصول",
requestSentTheTeamManagingThisAsset_56c7e0: "تم إرسال الطلب. سيراجعه الفريق الذي يدير هذا الأصل — وسيتم إعلامك عند الرد.",
theTeamManagingThisAssetDeclinedThis_072c77: "رفض الفريق الذي يدير هذا الأصل هذا الطلب. اتصل بهم مباشرة إذا كنت تعتقد أنه يجب أن يكون لديك حق الوصول.",
yourRelationshipToThisAsset_088c6c: "علاقتك بهذا الأصل",
selectARole_de9e0a: "حدد دورًا",
anythingToAddOptional_d0e207: "هل هناك أي شيء تود إضافته؟ (اختياري)",
egImTheTenantAtThisProperty_900046: "مثال: أنا المستأجر في هذا العقار",
staySignedIn_e5f5f7: "البقاء مسجلاً للدخول",
signatureCanvas_b150c4: "لوحة التوقيع",
opensTheTimeSelector_03fd5a: "يفتح محدد الوقت",
rowDensity_0a44a7: "كثافة الصف",
pullingTheLatestActivityForThisRequest_3eb3bd: "جارٍ جلب آخر نشاط لهذا الطلب.",
selectARequest_e23d7c: "حدد الطلب",
chooseARequestToSeeItsDetail_17587d: "اختر طلبًا لمعرفة تفاصيله ونشاطه.",
caseTimeline_ea3757: "الجدول الزمني للحالة",
addACheck_a948e9: "إضافة فحص",
cancelAddingACheck_a8ca4e: "إلغاء إضافة فحص",
searchChecklists_bf435d: "البحث في قوائم التحقق…",
buildANewChecklistToUseAs_eeb155: "أنشئ قائمة مرجعية جديدة لاستخدامها كفحص",
buildANewChecklist_4597c6: "أنشئ قائمة مرجعية جديدة",
requireThisCheckBeforeTheJobCan_75004c: "اشتراط هذا الفحص قبل إكمال المهمة",
requiredToCompleteTheJob_93fe15: "مطلوب لإكمال أمر العمل",
offByDefaultARequiredCheckBlocks_83f24c: "معطّل افتراضيًا. الفحص المطلوب يمنع الإكمال حتى يتم الانتهاء منه.",
sendACalendarInviteToSomeoneAt_1ef692: "أرسل دعوة تقويم إلى شخص في موقع الأصل",
optionalTheyllGetAnEmailCalendarInvite_f3c0fa: "اختياري - سيحصلون على دعوة تقويم عبر البريد الإلكتروني (.ics) لهذه الفترة الزمنية.",
inviteToCalendar_f4347a: "دعوة إلى التقويم",
thisCheckHasNoSteps_3d81af: "لا يحتوي هذا الفحص على خطوات",
checkChangedTitle: "قام شخص آخر بتحديث هذا الفحص",
checkChangedBody: "إجاباته معروضة الآن. أجب مرة أخرى حيث تحتاج.",
theTemplateItCameFromIsEmpty_dee3b8: "قائمة التحقق الذي جاء منه فارغ. قم بتحرير قائمة التحقق لإضافة خطوات، ثم قم بإرفاقه مرة أخرى.",
savedOnThisDeviceWillSyncWhen_3db4e0: "تم الحفظ على هذا الجهاز - ستتم مزامنته عند معاودة الاتصال بالإنترنت",
prepareWork_8aa4da: "تحضير العمل",
loadingWorkContext_c860da: "جارٍ تحميل سياق العمل",
reopenCase_a32ef8: "إعادة فتح الطلب",
reopen_61e05d: "إعادة فتح",
conversation_2a20c7: "محادثة",
writeAReply_dd081e: "اكتب ردًا…",
escalated_aff666: "تم التصعيد",
closeWithoutAResponse_3bf706: "إغلاق دون رد",
closeWithoutResponse_6c6096: "إغلاق دون استجابة",
automateThisChase_49d451: "أتمتة هذه المتابعة",
couldntLoadYourTemplates_b41115: "تعذّر تحميل قوائم تحققك",
upcomingVisits_ecb005: "الزيارات القادمة",
theTeamHasPlannedWorkHereAnd_78e2ed: "لقد خطط الفريق للعمل هنا وطلب منك تأكيد إمكانية تواجد شخص ما هناك.",
whoWillLetUsIn_66de4a: "من سيسمح لنا بالدخول؟",
noOneNeeded_4ab28b: "لا حاجة لأحد",
theyaposllBeAskedToConfirmTheVisit_d8cb82: "سيُطلب منهم تأكيد وقت الزيارة أو اقتراح موعد مختلف.",
sort_8b335a: "الترتيب:",
egReplaceWornBelt_49815f: "على سبيل المثال استبدل الحزام البالي",
tryLoadingChecklistsAgain_bd84f3: "حاول تحميل قوائم التحقق مرة أخرى",
noChecklistMatchesThisAssetTypeYet_d47d21: "لا توجد قائمة مرجعية تطابق نوع الأصول هذا حتى الآن.",
createAChecklist_02f012: "قم بإنشاء قائمة مرجعية",
createANewChecklistTemplate_ec189b: "قم بإنشاء قائمة تحقق جديد",
newChecklist_d80825: "قائمة مرجعية جديدة",
when_b2028c: "متى؟",
chooseWhenThisWorkShouldHappen_78b867: "اختر متى يجب أن يتم هذا العمل",
later_56e2f5: "لاحقاً",
howLongWillItTake_5c9649: "كم من الوقت سوف يستغرق؟",
suggestedTimes_aa2e2b: "الأوقات المقترحة",
noSlotFitsBeforeTheDueDate_8c442c: "لا توجد خانة مناسبة قبل تاريخ الاستحقاق — يحتاج العمل إلى مزيد من الوقت، أو مُعيَّن آخر، أو موعد نهائي تم نقله.",
howToRunIt_5809c8: "كيفية تشغيله",
endsOptional_92d6de: "ينتهي (اختياري)",
maxTimes_e58588: "الحد الأقصى لعدد المرات",
advanceTheSeries_2f1cf7: "تقديم السلسلة",
skipARunIfThePreviousOne_1b5907: "تخطَّ المرة التالية إذا كانت السابقة لا تزال مفتوحة",
remindMe_25df3f: "ذكرني",
anythingTheInspectorShouldKnow_af9eeb: "أي شيء يجب أن يعرفه المفتش",
assignTo_cc7907: "تعيين إلى",
theContractorYouAwardOrHandThis_9cbde2: "المقاول الذي تُرسي عليه هذه المهمة أو تسلّمها إليه. اختياره هنا لا يعني تعيينه — الترسية هي التي تفعل ذلك.",
checks_5098dd: "الفحوصات",
optionalAPrecheckConfirmsItIsSafe_db4e1f: "اختياري. يؤكد الفحص المسبق أن البدء آمن؛ ويؤكد الفحص اللاحق العمل قبل المغادرة. الفحوصات المضافة هنا مطلوبة، لذلك لا يمكن إكمال المهمة حتى يتم الانتهاء منها.",
analysingOnDevice_54be55: "جارٍ التحليل على الجهاز…",
codes_199993: "رموز",
meterReadings_a3c12c: "قراءات العدادات",
dates_842b7b: "التواريخ",
detected_74fb2c: "مُكتَشَف",
extractedText_5ea632: "النص المستخرج",
noInformationWasExtractedOnDevice_80b803: "لم يتم استخراج أي معلومات على الجهاز.",
enhancingWithAI_8078cd: "جارٍ التحسين بالذكاء الاصطناعي…",
aIEnhancementWillBeAvailableWhenYoure_ff5c7e: "سيتوفر التحسين بالذكاء الاصطناعي عند عودتك للاتصال بالإنترنت. يتم حفظ كل ما تمت قراءته على هذا الجهاز.",
summariseJourney_846b25: "تلخيص رحلة العمل",
loadedMatchesMoreAssetsAreAvailable_b38944: "تم تحميل {{value1}} من النتائج المطابقة. تتوفر أصول أخرى.",
showing_6ec0cc: "العرض: {{value1}}",
organisations_b83a9b: "المؤسسات{{value1}}",
openJobs_31f2a1: "أوامر العمل المفتوحة{{value1}}",
viewAll_f6220a: "عرض الكل · {{value1}}",
latest_a94fea: "الأحدث: {{value1}}",
previous_b3f133: "السابق: {{value1}}",
risk_ad0435: "المخاطر: {{value1}} ({{value2}})",
health_c90470: "الصحة: {{value1}} ({{value2}})",
compliance_49ba65: "الامتثال: {{value1}} ({{value2}})",
confidenceReviewBeforeApplying_a8e435: "{{value1}} ثقة {{value2}}. راجع قبل التطبيق.",
confidenceReviewBeforeApplying_050de9: "{{value1}} ثقة بنسبة {{value2}}٪. راجع قبل التطبيق.",
itWillBeCreatedAsCommissionIt_d1903a: "سيُنشأ بصفة {{value1}}. شغّله من صفحة الأصل عندما يصبح جاهزًا — فحص، ثم أي أوامر عمل تنتج عنه.",
upToPhotosOptionalTapThePreview_750506: "حتى {{value1}} صور — اختياري. اضغط على المعاينة أو استخدم الأزرار أدناه.",
tapToAddAnother_f06704: "اضغط لإضافة أخرى ({{value1}}/{{value2}})",
upToPhotosTotal_59c8b8: "حتى {{value1}} صور إجمالًا",
headsUpAlreadyUsesThisIDSerial_108120: "تنبيه: \"{{value1}}\" يستخدم هذا المعرّف / الرقم التسلسلي بالفعل.",
mo_8759d1: "{{value1}} شهر",
upToPhotosOptionalSameAsWhen_a03894: "حتى {{value1}} صور (اختياري). كما عند إنشاء أصل — اضغط على المعاينة أو استخدم الكاميرا / المعرض لإضافة المزيد.",
addAnotherPhoto_634f18: "إضافة صورة أخرى ({{value1}}/{{value2}})",
groups_104467: "المجموعات: {{value1}}",
items_b74542: "العناصر: {{value1}}",
required_40bdfd: "المطلوبة: {{value1}}",
conditionalRules_047d88: "القواعد الشرطية: {{value1}}",
currentVersionIsVSavingFromThis_07a9f2: "الإصدار الحالي هو v{{value1}}. الحفظ من هذا المحرر سينشئ v{{value2}}.",
categories_5b1690: "الفئات: {{value1}}",
depth_5fb610: "العمق: {{value1}}",
evidence_6674e1: "الأدلة: {{value1}}",
objectiveLengthChars_a7cb1d: "طول الهدف: {{value1}} حرفًا",
runID_27348d: "معرّف التشغيل: {{value1}}",
estimatedDurationMin_a210a3: "المدة المقدّرة: {{value1}} دقيقة",
responseDeadline_834634: "الموعد النهائي للرد: {{value1}}",
targetStart_cb37f8: "البداية المستهدفة: {{value1}}",
targetEnd_f9f809: "النهاية المستهدفة: {{value1}}",
estimatedBudget_070f47: "الميزانية المقدّرة: {{value1}} {{value2}}",
attachedPhotos_740082: "الصور المرفقة · {{value1}}",
category_5e6549: "الفئة: {{value1}}",
urgency_3bf5ac: "درجة الاستعجال: {{value1}}",
dueDate_279007: "تاريخ الاستحقاق: {{value1}}",
type_45c583: "النوع: {{value1}}",
pleaseRespondBy_ec61f2: "يرجى الرد قبل {{value1}}",
playVideo_dbbc47: "تشغيل الفيديو {{value1}}",
yourReason_882f62: "سببك: \"{{value1}}\"",
twofactorOfEnrolled_3402d7: "التحقق بخطوتين: {{value1}} من {{value2}} مسجّلون",
currencyCommunication_43aa12: "العملة: {{value1}} · التواصل: {{value2}}",
errorsInView_5612eb: "الأخطاء في العرض: {{value1}}",
when_f062b4: "متى: {{value1}}",
locale_469d05: "اللغة: {{value1}}",
credits_ae86ee: "الأرصدة: {{value1}} ({{value2}})",
entity_1fba91: "الكيان: {{value1}}",
step_0d893e: "الخطوة {{value1}}",
lastSuccessfulSyncLastFailedSyncNone_8b8bea: "آخر مزامنة ناجحة: {{value1}} · آخر مزامنة فاشلة: لا شيء مسجّل",
credentialSecretHiddenAfterCreationRotatedRevoked_326665: "بيانات الاعتماد: السر مخفي بعد الإنشاء · تم التدوير {{value1}} · تم الإلغاء {{value2}}",
status_ac4b0a: "الحالة: {{value1}}",
lastSuccessfulSync_d6b22a: "آخر مزامنة ناجحة: {{value1}}",
lastFailedSync_e7a87b: "آخر مزامنة فاشلة: {{value1}}",
logsHistory_117ea0: "السجلات / التاريخ: {{value1}}",
suggested_bfc937: "مقترح: {{value1}} · {{value2}}٪",
row_69394c: "الصف {{value1}}",
updated_3ada36: "المحدّثة: {{value1}}",
newSitesCreated_a610d0: "المواقع الجديدة المنشأة: {{value1}}",
skippedByConflictPolicy_e92870: "المتخطاة بسبب سياسة التعارض: {{value1}}",
failed_1c734b: "الفاشلة: {{value1}}",
pOST_39bb77: "POST {{value1}}",
credentialTokenRotated_3254bf: "بيانات الاعتماد: رمز {{value1}} {{value2}}...{{value3}} · تم التدوير {{value4}}",
invocations_1e09a7: "{{value1}} استدعاء",
lastSuccess_204f28: "آخر نجاح: {{value1}}",
lastFailure_fe19b0: "آخر فشل: {{value1}}",
authTypeHeader_b1a0ff: "نوع المصادقة: {{value1}}. الترويسة: {{value2}}.",
secretState_e4463d: "حالة السر: {{value1}}.",
request_65ee72: "الطلب: {{value1}}",
response_7fff2f: "الاستجابة: {{value1}}",
statusRecentAssistantInvocations_a6c770: "الحالة: {{value1}} • استدعاءات المساعد الأخيرة: {{value2}}",
lastInvocation_8b8558: "آخر استدعاء: {{value1}}",
lastError_e74e5f: "آخر خطأ: {{value1}}",
aHostedMCPEndpointForThisWorkspace_2ee242: "نقطة نهاية MCP مستضافة لمساحة العمل هذه: {{value1}}",
toolsAndResourcesEachFilteredByWorkspace_bdcaa8: "{{value1}} أداة و{{value2}} موردًا، كلٌّ منها مُرشّح حسب مساحة العمل ونطاقات حساب الخدمة.",
reads_a89270: "القراءات: {{value1}}",
writes_532f15: "الكتابات: {{value1}}",
path_676484: "المسار: {{value1}}",
scopes_993717: "النطاقات: {{value1}} {{value2}}",
expiresCreated_8b46c7: "ينتهي {{value1}} • أُنشئ {{value2}}",
preview_36c78a: "معاينة: {{value1}}",
ms_588b6b: "{{value1}} مللي ثانية • {{value2}}",
credits_05f92c: "{{value1}} رصيد",
checks_05efc2: "{{value1}}{{value2}}٪ · {{value3}} فحوصات",
dataQuality_984221: "{{value1}} · جودة البيانات {{value2}}٪",
reason_74bb8e: "السبب: {{value1}}",
showingRequestsFrom_dc8278: "عرض الطلبات من {{value1}}.",
typeToConfirm_fac0ca: "اكتب {{value1}} للتأكيد",
lastCycles_9f5334: "آخر {{value1}} دورات",
openWork_cc107a: "العمل المفتوح · {{value1}}",
tags_6e1f36: "الوسوم: {{value1}}",
team_fff0a5: "الفريق: {{value1}}",
compliance_89f882: "الامتثال · {{value1}}",
registered_8b441e: "مسجّل {{value1}}",
ofCoreFieldsFilled_0f25e0: "{{value1}} من {{value2}} حقول أساسية معبّأة",
stillMissing_f3dd5e: "لا يزال ناقصًا: {{value1}}",
appliedReviewTheFieldsBelowTheySave_866743: "تم تطبيق {{value1}} {{value2}} — راجع الحقول أدناه؛ تُحفظ تلقائيًا.",
poor_904815: "{{value1}} ضعيف",
watch_a1d644: "{{value1}} تحت المراقبة",
good_aaf5c2: "{{value1}} جيد",
unscored_e4e509: "{{value1}} غير مقيّم",
criticality_b7cd47: "الأهمية الحرجة {{value1}} · {{value2}}",
open_a1601a: "{{value1}} {{value2}} مفتوحة",
lastInspected_71de34: "آخر فحص · {{value1}}",
rulesCalculated_3cece2: "القواعد {{value1}} · محسوب {{value2}}",
likelihoodImpact_b6a9fb: "الاحتمال {{value1}} × الأثر {{value2}}",
"5Weight_d64551": "{{value1}}/5 · {{value2}} · وزن {{value3}}٪",
standaloneScoresBeforeLinkAdjustmentLI_1c934f: "الدرجات المستقلة قبل تعديل الروابط: الاحتمال {{value1}} · الأثر {{value2}}",
relationshipAdjustmentsAppliedLI_17818d: "تعديلات العلاقات المطبّقة: الاحتمال {{value1}}{{value2}} · الأثر {{value3}}{{value4}}",
lRawRoundedIRawRounded_c4c6f6: "الاحتمال الخام {{value1}} ← مقرّب {{value2}}؛ الأثر الخام {{value3}} ← مقرّب {{value4}}",
rules_4b3591: "القواعد {{value1}}{{value2}}",
skipped_2fd804: "متخطى{{value1}}",
reportRef_4ee599: "مرجع التقرير: {{value1}}",
completed_57e944: "اكتمل {{value1}}",
round_6178c9: "الجولة {{value1}} · {{value2}}",
firstShared_249645: "أول مشاركة {{value1}}{{value2}}",
dueBy_d51c85: "يستحق بحلول {{value1}}",
scheduledFor_37e8f3: "مجدول في {{value1}}",
confidence_615dda: "الثقة: {{value1}}",
useExtractedTotalAsActualCost_463a4f: "استخدام الإجمالي المستخرج{{value1}}{{value2}} كتكلفة فعلية",
fromQtyUnit_c1c1c3: "من الكمية × الوحدة: {{value1}}{{value2}}{{value3}}",
estimate_3a8133: "التقدير: {{value1}}",
actual_e5762d: "الفعلي: {{value1}}",
vsEstimate_5939a7: "مقابل التقدير: {{value1}}{{value2}}{{value3}} ({{value4}}{{value5}}٪)",
materialsSubtotal_f5bcb3: "المجموع الفرعي للمواد: {{value1}}{{value2}}",
inspected_517599: "تم الفحص {{value1}}",
theFullReportFindingsPhotosRecommendationsAnd_e1e094: "التقرير الكامل — النتائج والصور والتوصيات وأي تكاليف — يُشارك مع الأشخاص المعتمدين فقط. {{value1}}",
selected_deace8: "{{value1}} محدد",
signedBy_06a094: "وقّعه {{value1}}",
tapSummariseJourneyToTryAgain_f327c1: "{{value1}} اضغط على \"تلخيص رحلة العمل\" للمحاولة مرة أخرى.",
},
close: "إغلاق",
back: "رجوع",
next: "التالي",
detailTabs: {
  scrollForward: "عرض المزيد من علامات التبويب",
  scrollBack: "عرض علامات التبويب السابقة",
},
freePeriod: {
  until: "مجاني حتى {{date}}. اختر خطة ليستمر عمل مساحة العمل بعد ذلك.",
  ended: "انتهت فترتك المجانية وأصبحت مساحة العمل للقراءة فقط. اختر خطة لمواصلة العمل. لم يُحذف أي شيء.",
},
aiReport: {
  link: "إبلاغ",
  title: "الإبلاغ عن رد الذكاء الاصطناعي هذا",
  body: "أخبرنا بما هو خطأ فيه. نحتفظ بالنص الذي عُرض عليك لنتمكن من مراجعته.",
  offensive: "مسيء",
  harmful: "ضار أو غير آمن",
  wrong: "خاطئ أو مضلل",
  cancel: "إلغاء",
  sentTitle: "تم إرسال البلاغ",
  sentBody: "شكرًا لك. نراجع كل بلاغ.",
  failedTitle: "تعذر إرسال البلاغ",
},
collaboratorUpgrade: {
contractorTitle: "أدِر مهامك وعملاءك",
contractorBody: "احتفظ بعملائك ومهامك وفواتيرك هنا، مع أرصدة الذكاء الاصطناعي الخاصة بك. يبقى العمل الذي تنجزه للآخرين كما هو.",
requesterTitle: "احتفظ بسجل الصيانة الخاص بك",
requesterBody: "تابع العقارات والمعدات التي تعتني بها بنفسك، مع مهامها وفحوصاتها ومستنداتها. يبقى ما شورك معك كما هو.",
recipientTitle: "افحص أصولك بالطريقة نفسها",
recipientBody: "أجرِ فحوصات وتقارير مثل هذا على أصولك. يبقى ما شورك معك كما هو.",
otherTitle: "أدِر أصولك",
otherBody: "أنشئ مساحة عمل خاصة بك لأصولك وأعمالك. يبقى ما تنجزه للآخرين كما هو.",
cta: "عرض الخطط",
freeReady: "مساحة عملك جاهزة. أضف أول أصل من زر +.",
},
aiCost: {
included: "مقدَّم من {{host}} · يتبقى {{n}} رصيدًا هذا الشهر",
includedUsed: "لم يعد {{host}} يقدّم الذكاء الاصطناعي هذا الشهر. يمكنك استخدام أرصدتك.",
  generateFailed: "تعذّرت كتابة المسودة. حاول مرة أخرى، أو أنشئ قائمة التحقق بنفسك.",
  buy: "شراء رصيد",
  onWeb: "يُشترى الرصيد من AssetWRX على الويب، أو يصل مع رصيدك الشهري.",
  buyHint: "اشترِ باقة رصيد للمتابعة، أو انتظر رصيدك الشهري.",
  askAdmin: "اطلب من مالك مساحة العمل أو مسؤولها شراء رصيد، أو انتظر رصيدك الشهري.",
  askNamed: "اطلب من {{name}} شراء رصيد، أو انتظر رصيدك الشهري.",
  shortUnknown: "لا يتبقى رصيد ذكاء اصطناعي كافٍ لهذا.",
  short: "الرصيد غير كافٍ: يلزم {{n}}، والمتبقي {{balance}}.",
  hint: "رصيد الذكاء الاصطناعي المستخدم: {{n}} · المتاح: {{balance}}",
},
aiGenerate: {
  discard: "تجاهل",
  keep: "الإبقاء عليها",
  discardBody: "لن تُحفظ. يمكنك كتابة مسودة جديدة من النموذج.",
  discardTitle: "تجاهل هذه المسودة؟",
  saveDraft: "حفظ المسودة",
  unsavedMessage: "لم تُحفظ مسودة قائمة التحقق بالذكاء الاصطناعي بعد. هل تريد المغادرة وفقدانها؟",
  leaveReviewTitle: "مغادرة المراجعة؟",
  savedTitle: "تم حفظ قائمة التحقق",
  feedbackFailedBody: "تعذّر تسجيل الملاحظات. تم حفظ قائمة التحقق بنجاح.",
  goToTemplate: "الانتقال إلى قائمة التحقق",
  saveFailed: "تعذّر حفظ قائمة التحقق.",
  leaveReviewBody: "لن تُحفظ مسودتك. تجاهلها من شاشة المراجعة لتسجيل ملاحظاتك.",
  stay: "البقاء",
  moreOptionsSummary: "المدة والصور والترتيب والأسلوب",
  moreOptions: "خيارات أخرى",
  baseLabel: "نسخ أسلوب (اختياري)",
  goal: {
    fail_only_evidence: "صور عند الفشل فقط",
    physical_flow: "ترتيب الجولة",
    compliance: "الالتزام بالقواعد",
  },
  goalLabel: "ترتيبها أيضًا من أجل (اختياري)",
  evidence: {
    always: "لكل بند",
    optional: "عندما يرغب المفتش",
    fail_only: "فقط عند الفشل",
  },
  evidenceLabel: "متى تُطلب الصور",
  depth: {
    detailed: "شامل",
    standard: "قياسي",
    lite: "فحص سريع",
  },
  depthLabel: "مستوى التفصيل",
  noAsset: "لا أصل محدد",
  basePlaceholder: "اختر قائمة تحقق لنسخ أسلوبه",
  baseSelected: "محدد",
  baseNone: "لا شيء",
},
aiDisclosure: {
title: "تستخدم ميزات الذكاء الاصطناعي Google",
body: "يرسل AssetWRX الصور والنصوص المعنية إلى Google (Gemini) لتنفيذ ذلك. لا تستخدمها Google للتدريب. قد تساهم صور الأدلة التي تحتفظ بها من Vision في تحسين WRX Vision ما لم يوقف مالك مساحة العمل ذلك. التفاصيل في الملف الشخصي ← الخصوصية والبيانات.",
allow: "السماح",
notNow: "ليس الآن",
declined: "لم يُستخدم الذكاء الاصطناعي. يمكنك السماح به في المرة القادمة التي تستخدم فيها ميزة ذكاء اصطناعي.",
},
sessionExpiryBanner: {
expiresIn_zero: "ستنتهي جلستك خلال {{count}} دقيقة.",
expiresIn_one: "ستنتهي جلستك خلال دقيقة واحدة.",
expiresIn_two: "ستنتهي جلستك خلال دقيقتين.",
expiresIn_few: "ستنتهي جلستك خلال {{count}} دقائق.",
expiresIn_many: "ستنتهي جلستك خلال {{count}} دقيقةً.",
expiresIn_other: "ستنتهي جلستك خلال {{count}} دقيقة.",
},
offlineStrip: {
offline: "غير متصل · تتم المزامنة عند إعادة الاتصال",
offlineQueued_zero: "غير متصل · لا تغييرات بانتظار المزامنة",
offlineQueued_one: "غير متصل · تغيير واحد بانتظار المزامنة",
offlineQueued_two: "غير متصل · تغييران بانتظار المزامنة",
offlineQueued_few: "غير متصل · {{count}} تغييرات بانتظار المزامنة",
offlineQueued_many: "غير متصل · {{count}} تغييرًا بانتظار المزامنة",
offlineQueued_other: "غير متصل · {{count}} تغيير بانتظار المزامنة",
syncing_zero: "جارٍ المزامنة…",
syncing_one: "جارٍ مزامنة تغيير واحد…",
syncing_two: "جارٍ مزامنة تغييرين…",
syncing_few: "جارٍ مزامنة {{count}} تغييرات…",
syncing_many: "جارٍ مزامنة {{count}} تغييرًا…",
syncing_other: "جارٍ مزامنة {{count}} تغيير…",
queued_zero: "لا تغييرات بانتظار المزامنة",
queued_one: "تغيير واحد بانتظار المزامنة",
queued_two: "تغييران بانتظار المزامنة",
queued_few: "{{count}} تغييرات بانتظار المزامنة",
queued_many: "{{count}} تغييرًا بانتظار المزامنة",
queued_other: "{{count}} تغيير بانتظار المزامنة",
},
photoLimit: {
title: "تم بلوغ الحد الأقصى للصور",
body_zero: "لا يمكنك إرفاق أي صورة هنا. أزل صورة لإضافة أخرى.",
body_one: "يمكنك إرفاق صورة واحدة كحد أقصى هنا. أزل صورة لإضافة أخرى.",
body_two: "يمكنك إرفاق ما يصل إلى صورتين هنا. أزل صورة لإضافة أخرى.",
body_few: "يمكنك إرفاق ما يصل إلى {{count}} صور هنا. أزل صورة لإضافة أخرى.",
body_many: "يمكنك إرفاق ما يصل إلى {{count}} صورةً هنا. أزل صورة لإضافة أخرى.",
body_other: "يمكنك إرفاق ما يصل إلى {{count}} صورة هنا. أزل صورة لإضافة أخرى.",
},
mapBoundary: {
start: "اضغط على زوايا هذا الموقع",
more_zero: "لا حاجة إلى الضغط على زوايا أخرى",
more_one: "اضغط على زاوية واحدة أخرى على الأقل",
more_two: "اضغط على زاويتين أخريين على الأقل",
more_few: "اضغط على {{count}} زوايا أخرى على الأقل",
more_many: "اضغط على {{count}} زاويةً أخرى على الأقل",
more_other: "اضغط على {{count}} زاوية أخرى على الأقل",
adjust: "اسحب زاوية لضبطها، أو احفظ",
},
importSites: {
listSeparator: "، ",
moreNames_zero: "، +{{count}} أخرى",
moreNames_one: "، +{{count}} آخر",
moreNames_two: "، +{{count}} آخران",
moreNames_few: "، +{{count}} أخرى",
moreNames_many: "، +{{count}} أخرى",
moreNames_other: "، +{{count}} أخرى",
confirmTitle_zero: "إنشاء ما يصل إلى {{count}} موقع جديد؟",
confirmTitle_one: "إنشاء ما يصل إلى موقع جديد واحد؟",
confirmTitle_two: "إنشاء ما يصل إلى موقعين جديدين؟",
confirmTitle_few: "إنشاء ما يصل إلى {{count}} مواقع جديدة؟",
confirmTitle_many: "إنشاء ما يصل إلى {{count}} موقعًا جديدًا؟",
confirmTitle_other: "إنشاء ما يصل إلى {{count}} موقع جديد؟",
confirmBody_zero: "سينشئ هذا الاستيراد ما يصل إلى {{count}} موقع جديد ويربط الأصول بها:\n{{names}}{{more}}\n\nيُعاد استخدام المواقع الموجودة عندما يتطابق الاسم. ارجع وصحّح جدول البيانات أولًا إذا كان أيٌّ منها مكررًا أو فيه خطأ إملائي.",
confirmBody_one: "سينشئ هذا الاستيراد ما يصل إلى موقع جديد واحد ويربط الأصول به:\n{{names}}{{more}}\n\nيُعاد استخدام المواقع الموجودة عندما يتطابق الاسم. ارجع وصحّح جدول البيانات أولًا إذا كان أيٌّ منها مكررًا أو فيه خطأ إملائي.",
confirmBody_two: "سينشئ هذا الاستيراد ما يصل إلى موقعين جديدين ويربط الأصول بهما:\n{{names}}{{more}}\n\nيُعاد استخدام المواقع الموجودة عندما يتطابق الاسم. ارجع وصحّح جدول البيانات أولًا إذا كان أيٌّ منها مكررًا أو فيه خطأ إملائي.",
confirmBody_few: "سينشئ هذا الاستيراد ما يصل إلى {{count}} مواقع جديدة ويربط الأصول بها:\n{{names}}{{more}}\n\nيُعاد استخدام المواقع الموجودة عندما يتطابق الاسم. ارجع وصحّح جدول البيانات أولًا إذا كان أيٌّ منها مكررًا أو فيه خطأ إملائي.",
confirmBody_many: "سينشئ هذا الاستيراد ما يصل إلى {{count}} موقعًا جديدًا ويربط الأصول بها:\n{{names}}{{more}}\n\nيُعاد استخدام المواقع الموجودة عندما يتطابق الاسم. ارجع وصحّح جدول البيانات أولًا إذا كان أيٌّ منها مكررًا أو فيه خطأ إملائي.",
confirmBody_other: "سينشئ هذا الاستيراد ما يصل إلى {{count}} موقع جديد ويربط الأصول بها:\n{{names}}{{more}}\n\nيُعاد استخدام المواقع الموجودة عندما يتطابق الاسم. ارجع وصحّح جدول البيانات أولًا إذا كان أيٌّ منها مكررًا أو فيه خطأ إملائي.",
backToPreview: "العودة إلى المعاينة",
createAndImport: "إنشاء واستيراد",
actionCreate: "إنشاء",
actionUpdate: "تحديث",
actionSkip: "تخطي",
actionError: "خطأ",
calloutNew_zero: "سيُنشأ ما يصل إلى {{count}} موقع جديد",
calloutNew_one: "سيُنشأ ما يصل إلى موقع جديد واحد",
calloutNew_two: "سيُنشأ ما يصل إلى موقعين جديدين",
calloutNew_few: "سيُنشأ ما يصل إلى {{count}} مواقع جديدة",
calloutNew_many: "سيُنشأ ما يصل إلى {{count}} موقعًا جديدًا",
calloutNew_other: "سيُنشأ ما يصل إلى {{count}} موقع جديد",
calloutMatched: "مواقع مطابَقة بالاسم",
linkExisting_zero: "تُربط الأصول بـ {{count}} موقع موجود مطابَق بالاسم.",
linkExisting_one: "تُربط الأصول بموقع واحد موجود مطابَق بالاسم.",
linkExisting_two: "تُربط الأصول بموقعين موجودين مطابَقين بالاسم.",
linkExisting_few: "تُربط الأصول بـ {{count}} مواقع موجودة مطابَقة بالاسم.",
linkExisting_many: "تُربط الأصول بـ {{count}} موقعًا موجودًا مطابَقًا بالاسم.",
linkExisting_other: "تُربط الأصول بـ {{count}} موقع موجود مطابَق بالاسم.",
matchedCaseInsensitive: "تُطابَق الأسماء مع المواقع الموجودة (دون تمييز بين الأحرف الكبيرة والصغيرة).",
reuseNote: " يُعاد استخدام المواقع الموجودة عندما يتطابق الاسم — وتؤكد أنت المواقع الجديدة قبل الاستيراد.",
},
attachmentsPanel: {
title: "المرفقات",
all: "الكل",
empty: "لا توجد مرفقات بعد.",
kind: { photo: "الصور", video: "الفيديوهات", audio: "الصوت", document: "الملفات" },
source: {
fallback: "مرفق",
"job.completion_photo": "صورة الإنجاز",
"job.completion_video": "فيديو الإنجاز",
"job.completion_voice_note": "ملاحظة صوتية للإنجاز",
"job.receipt": "إيصال",
"job.activity_attachment": "مرفق من سجل النشاط",
"inspection.item_photo": "صورة الفحص",
"inspection.item_video": "فيديو الفحص",
"inspection.item_voice_note": "ملاحظة صوتية للفحص",
},
},
};
